<template>
    <el-container>
        <el-header>
            <h1>趣头条批搭</h1>
        </el-header>
        <el-main>
            <div class="plan-container">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item">账户信息</div>
                    <!-- 推广目的 -->
                    <el-form-item label="查询指令:" label-width="160px">

                        <el-select v-model="btgjc" filterable clearable placeholder="请选择" @change="recordsChange">
                            <el-option v-for="(item, i) in records" :key="i" :label="item.directiveName" :value="item.id">
                            </el-option>
                        </el-select>
                        <el-button type="primary"  @click="relist" class="confirm-btn">刷新</el-button>
                        <div class="item-orient">
                            <el-tag v-for="(item, index) in ids_list" :key="index" type="success">
                                {{ item.accountName }}
                            </el-tag>
                            
                        </div>
                        
                    </el-form-item>
                    <div data-v-da9757c6="" class="adgroup-item">计划基本属性</div>
                    <!-- 推广目的 -->
                    <el-form-item label="推广目的:" label-width="160px">
                        <el-radio-group v-model="form.optimization_goal">
                            <el-radio-button v-for="item in optimization_goal_group" :key="item.value"
                                :label="item.value">{{ item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 营销场景 -->
                    <el-form-item label="营销场景" label-width="160px">
                        <el-radio-group v-model="form.app_marketing_type">
                            <el-radio-button label="ACQUISITION">拉新</el-radio-button>
                            <el-radio-button label="ACTIVATION">拉活</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 广告计划名称 -->
                    <!-- <el-form-item label="广告计划名称" label-width="160px">
                        <el-input v-model="form.campaign_name" placeholder="请输入广告计划名称"></el-input>
                    </el-form-item> -->

                    <!-- 投放日期 -->
                    <el-form-item label="投放日期" label-width="160px">
                        <el-date-picker v-model="form.dateRange" @change="PlacementTimehange" type="daterange"
                            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 280px;">
                        </el-date-picker>
                    </el-form-item>

                    <!-- 投放预算 -->
                    <el-form-item label="投放预算(元/天)" label-width="160px">
                        <el-input v-model="form.budget" placeholder="请输入投放预算">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <!-- 明日投放预算状态 -->
                    <!-- <el-form-item label="明日投放预算状态" label-width="152px">
                        <el-tooltip content="一旦开启，该计划将从开启的第二天开始按明日投放预算投放，直到关闭" placement="top" style="margin-right: 10px;">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                        <el-radio-group v-model="form.budgetStatus">
                            <el-radio-button label="1">关闭</el-radio-button>
                            <el-radio-button label="0">开启</el-radio-button>
                        </el-radio-group>
                    </el-form-item> -->
                    <div data-v-da9757c6="" class="adgroup-item">单元基本属性</div>
                    <!-- <el-form-item label="所属计划" label-width="152px">
                        <el-select v-model="form2.plan" placeholder="请选择计划">
                            <el-option v-for="item in planOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="单元名称" prop="name" label-width="152px">
                        <el-input v-model="form2.adgroup_name" placeholder="请输入单元名称"></el-input>
                    </el-form-item>

                    <div data-v-da9757c6="" class="adgroup-item2">流量类型</div>
                    <el-form-item label="投放媒体" prop="mediaType" label-width="152px">
                        <el-radio-group v-model="form2.mediaType">
                            <el-radio-button label="OPTIMIZATION">优选</el-radio-button>
                            <el-radio-button label="SPECIFY">指定</el-radio-button>
                        </el-radio-group>
                        <div class="form-tip">系统自动优选媒体流量进行投放，并触达尽可能多的目标用户</div>

                        <div v-if="form2.mediaType === 'SPECIFY'" class="media-specify-box">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                                媒体名称
                            </el-checkbox>
                            <el-checkbox-group v-model="form2.selectedMedia">
                                <div style="margin-bottom: 10px;">

                                </div>
                                <el-checkbox v-for="media in mediaOptions" :key="media.value" :label="media.value">
                                    {{ media.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>

                    <el-form-item label="广告位类型" prop="adSlotType" label-width="152px">

                        <el-radio-group v-model="form2.adSlotType">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="SPECIFY">指定</el-radio-button>
                        </el-radio-group>

                        <div v-if="form2.adSlotType === 'SPECIFY'" class="adslot-specify-box">
                            <el-checkbox :indeterminate="adSlotisIndeterminate" v-model="adSlotcheckAll"
                                @change="adSlothandleCheckAllChange">全选</el-checkbox>
                            <el-checkbox-group v-model="form2.selectedAdSlots" @change="adSlothandleCheckedChange">
                                <el-checkbox v-for="slot in adSlotOptions" :key="slot.value" :label="slot.value">
                                    {{ slot.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>


                    <div data-v-da9757c6="" class="adgroup-item2">定向设置</div>

                    <el-form-item label="自定义人群包（定向）" prop="audienceOrientFilter" label-width="192px">
                        <div class="item-orient">
                            <!-- <span class="item-orient-label">兴趣人群包</span> -->
                            <el-cascader-panel v-model="selectedValue" :options="options" :props="cascaderProps"
                                @change="handleChange"></el-cascader-panel>
                        </div>
                    </el-form-item>
                    <el-form-item label="自定义人群包（排除）" prop="audienceOrientFilter" label-width="192px">
                        <div class="item-orient">
                            <!-- <span class="item-orient-label">兴趣人群包</span> -->
                            <el-cascader-panel v-model="selectedValue2" :options="options" :props="cascaderProps"
                                @change="handleChange2"></el-cascader-panel>
                        </div>
                    </el-form-item>







                    <el-form-item label="定向包" prop="dingxiangbao" label-width="152px">
                        <el-select v-model="form2.dingxiangbao" placeholder="请选择" @change="ddddccc">
                            <el-option v-for="item in dingxiangbao" :key="item.value" :label="item.pkgname"
                                :value="item.pkgjson">
                            </el-option>
                        </el-select>
                    </el-form-item>



                    <!-- 广告频次 -->
                    <div data-v-da9757c6="" class="adgroup-item2">广告频次</div>
                    <el-form-item label="展现频次" prop="name" label-width="152px">
                        <el-input v-model="form2.showFrequency" placeholder="展现频次(0-10,0不限频次)" type="number" min="0"
                            max="10"></el-input>
                        <div class="form-tip">*横幅、开屏广告建议设置2-3次，信息流建议2次以上</div>
                    </el-form-item>
                    <el-form-item label="点击频次(次)" prop="name" label-width="152px">
                        <el-input v-model="form2.clickFrequency" placeholder="点击频次(0-10,0不限频次)" type="number" min="0"
                            max="10"></el-input>
                    </el-form-item>


                    <!-- 出价 -->
                    <div data-v-da9757c6="" class="adgroup-item2">出价</div>
                    <!-- <el-form-item label="付费方式" prop="name" label-width="152px">
                        <el-button disabled>CPC</el-button>
                    </el-form-item> -->
                    <el-form-item label="付费方式" prop="chargeType" label-width="152px">
                        <el-radio-group v-model="form2.chargeType">
                            <el-radio-button label="CPC">CPC</el-radio-button>
                            <el-radio-button label="OCPM">OCPM</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="转化目标" prop="conversionGoal" label-width="152px" v-if="form2.chargeType == 'OCPM'">
                        <el-radio-group v-model="form2.conversionGoal">

                            <el-radio-button v-for="item in conversion_goal_group" :key="item.value" :label="item.value">{{
                                item.label }}</el-radio-button>

                        </el-radio-group>

                    </el-form-item>

                    <el-form-item label="同时优化深度转化" prop="deepConversionGoal" label-width="152px"
                        v-if="form2.chargeType == 'OCPM'">
                        <el-radio-group v-model="form2.deepConversionGoal">

                            <el-radio-button v-for="item in deep_conversion_goal_group" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>

                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="转化追踪方式" prop="conversionFrom" label-width="152px"
                        v-if="form2.chargeType == 'OCPM'">
                        <el-radio-group v-model="form2.conversionFrom">

                            <el-radio-button label="API" key="API">API回传</el-radio-button>

                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="出价(元)" prop="name" label-width="152px">
                        <el-input v-model="form2.bidPrice" placeholder="请输入出价" type="number" min="0"></el-input>
                    </el-form-item>
                    <el-form-item label="二段出价(元)" prop="cpaBid" label-width="152px" v-if="form2.chargeType == 'OCPM'">
                        <el-input v-model="form2.cpaBid" placeholder="请输入出价" type="number" min="0"></el-input>
                    </el-form-item>
                    <el-form-item label="三段出价(元)" prop="deepCpaBid" label-width="152px"
                        v-if="form2.chargeType == 'OCPM' && this.form2.deepConversionGoal != 'NO' && (form2.deepConversionGoal == 'CHARGE' || form2.deepConversionGoal == 'KEY_ACTION')">
                        <el-input v-model="form2.deepCpaBid" placeholder="请输入出价" type="number" min="0"></el-input>
                    </el-form-item>
                    <el-form-item :label="form2.deepConversionGoal === 'RETENTION' ? '目标次日留存率' :
                        form2.deepConversionGoal === 'TWO_RETENTION' ? '目标二留率' :
                            form2.deepConversionGoal === 'SIX_RETENTION' ? '目标六留率' : '目标留存率'" prop="retentionRate"
                        label-width="152px"
                        v-if="form2.chargeType == 'OCPM' && form2.deepConversionGoal != 'NO' && (form2.deepConversionGoal == 'RETENTION' || form2.deepConversionGoal == 'TWO_RETENTION' || form2.deepConversionGoal == 'SIX_RETENTION')">
                        <el-input-number v-model="form2.retentionRate" :min="10" :max="60" :step="1" :precision="0"
                            controls-position="right" style="width: 160px;">
                            <template #suffix>%</template>
                        </el-input-number> %
                    </el-form-item>

                    <div data-v-da9757c6="" class="adgroup-item2">效果优化</div>
                    <el-form-item label="调起优化" prop="conversionGoal" label-width="152px">
                        <el-radio-group v-model="form2.transfer_optimize">

                            <el-radio-button v-for="item in transfer_optimize_group" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>

                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="oCPM扩量工具" prop="ocpx_expand" label-width="152px" v-if="form2.chargeType == 'OCPM'">
                        <el-radio-group v-model="form2.ocpx_expand">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>
                    </el-form-item>


                    <div data-v-da9757c6="" class="adgroup-item">创意基础信息</div>
                    <!-- <el-form-item label="搭建策略" prop="number" label-width="152px">
                        <el-radio-group v-model="mixminvaluelate">
                            <el-radio-button label="重复"></el-radio-button>
                            <el-radio-button label="轮询"></el-radio-button>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="创意名称" prop="creativeName" label-width="152px">
                        <el-input v-model="form3.creativeName" placeholder="请输入创意名称"></el-input>
                    </el-form-item>

                    <el-form-item label="创意搭建数量" prop="number" label-width="152px">
                        <el-input type="number" v-model="form3.number" placeholder="请输入搭建数量" @change="form3Numberchange">

                        </el-input>

                    </el-form-item>
                    <el-form-item label="创意样式" prop="type" label-width="152px">
                        <div class="el-form-item__content">
                            <el-select v-model="form3.type" disabled>
                            </el-select>
                            <!-- 辅助操作按钮 -->
                            <el-button type="primary" plain style="margin-left: 16px;" @click="openStyleDialog">
                                点击选择
                            </el-button>

                        </div>
                    </el-form-item>

                    <div data-v-da9757c6="" class="adgroup-item2">推广产品信息</div>
                    <el-form-item label="推广分类" prop="sub_cate" label-width="152px">
                        <el-radio-group v-model="form3.sub_cate">
                            <el-radio-button label="ANDROID_APP">Android应用推广</el-radio-button>
                            <el-radio-button label="IOS_APP">iOS应用推广</el-radio-button>
                            <el-radio-button label="MINI_PROGRAM">微信小程序</el-radio-button>
                            <el-radio-button label="QUICK_APPS">快应用</el-radio-button>
                            <el-radio-button label="OTHER">其他</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="转化追踪方式 " prop="conversion_type" label-width="152px">
                        <el-radio-group v-model="form3.conversion_type">
                            <el-radio-button label="DEFAULT">无</el-radio-button>
                            <el-radio-button label="API_DOWNLOAD">API-APP内部转化</el-radio-button>
                            <el-radio-button label="API_LANDING_PAGE">API-落地页转化</el-radio-button>
                            <el-radio-button label="JS">JS布码</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="APP名称" prop="target_url_h5" label-width="152px"
                        v-if="this.form3.type != 'MOTIVATE_APP'">
                        <el-autocomplete class="inline-input" v-model="form3.app_name" :fetch-suggestions="querySearch"
                            placeholder="请输入APP名称" @select="handleSelecttype"></el-autocomplete>
                    </el-form-item>

                    <el-form-item label="素材" prop="app_logo" label-width="152px">
                        <el-button type="primary" @click="handleMaterialsdialog">
                            选择素材
                        </el-button>
                    </el-form-item>
                    <el-form-item :label="'标题：' + form3.title.length + '个'" label-width="152px"
                        v-if="this.form3.type != 'MOTIVATE_APP' && this.form3.type != 'MOTIVATE_VIDEO_HORIZONTAL' && this.form3.type != 'MOTIVATE_VIDEO_VERTICAL' && this.form3.type != 'OPEN_SCREEN' && this.form3.type != 'BANNER'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput"></el-input>
                        <div style="display: block;">
                            <div v-for="(line, index) in linesWithLimitError" :key="index"
                                style="color: red; font-size: 12px; margin-top: 5px;">
                                <div>第{{ index + 1 }}行字符限制在8-23个字 {{ line }} </div>
                            </div>

                        </div>
                    </el-form-item>
                    <el-form-item :label="'副标题：' + form3.second_title.length + '个'" label-width="152px"
                        v-if="this.form3.type != 'MOTIVATE_APP' && this.form3.type != 'MOTIVATE_VIDEO_HORIZONTAL' && this.form3.type != 'ENGAGEMENT' && this.form3.type != 'MOTIVATE_VIDEO_VERTICAL' && this.form3.type != 'TEXT_LINK' && this.form3.type != 'TEXT_LINK' && this.form3.type != 'OPEN_SCREEN' && this.form3.type != 'BANNER'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString2" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput2"></el-input>
                        <div style="display: block;">
                            <div v-for="(line, index) in linesWithLimitError2" :key="index"
                                style="color: red; font-size: 12px; margin-top: 5px;">
                                <div>第{{ index + 1 }}行字符限制在8-23个字 {{ line }} </div>
                            </div>

                        </div>
                    </el-form-item>


                    <el-form-item :label="'创意描述：' + form3.description.length + '个'" label-width="152px"
                        v-if="(this.form3.type == 'MOTIVATE_VIDEO_HORIZONTAL' && this.form3.type != 'TEXT_LINK' && this.form3.type != 'BIG_IMAGE' && this.form3.type != 'ENGAGEMENT' && this.form3.type != 'OPEN_SCREEN' && this.form3.type != 'BANNER') || (this.form3.type == 'MOTIVATE_VIDEO_VERTICAL' && this.form3.type != 'BIG_IMAGE' && this.form3.type != 'TEXT_LINK' && this.form3.type != 'ENGAGEMENT' && this.form3.type != 'OPEN_SCREEN' && this.form3.type != 'BANNER')">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString5" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput6"></el-input>

                    </el-form-item>

                    <el-form-item :label="'描述：' + form3.text_link_description.length + '个'" label-width="152px"
                        v-if="this.form3.type == 'TEXT_LINK'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString6" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput7"></el-input>

                    </el-form-item>
                    <el-form-item :label="'按钮文案：' + form3.text_link_btn.length + '个'" label-width="152px"
                        v-if="this.form3.type == 'TEXT_LINK'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString7" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput8"></el-input>

                    </el-form-item>
                    <el-form-item :label="'领取按钮文案：' + form3.btn_text.length + '个'" label-width="152px"
                        v-if="this.form3.type == 'ENGAGEMENT'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString8" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput9"></el-input>

                    </el-form-item>





                    <el-form-item :label="'应用简介：' + form3.app_introduction.length + '个'" label-width="152px"
                        v-if="this.form3.type == 'MOTIVATE_APP'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString11" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput4"></el-input>
                    </el-form-item>
                    <el-form-item :label="'内容描述：' + form3.app_desc.length + '个'" label-width="152px"
                        v-if="this.form3.type == 'MOTIVATE_APP'">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString4" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput5"></el-input>
                    </el-form-item>

                    <el-form-item label="动作类型" prop="play_action" label-width="152px"
                        v-if="this.form3.type == 'MOTIVATE_APP'">
                        <el-select v-model="form3.play_action" placeholder="请选择">
                            <el-option v-for="item in playActionOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="试玩时长" prop="play_duration" label-width="152px"
                        v-if="this.form3.type == 'MOTIVATE_APP'">
                        <el-select v-model="form3.play_duration" placeholder="请选择">
                            <el-option v-for="item in playDurationOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="激励视频plus" prop="motivate_video_autoplay" label-width="152px"
                        v-if="this.form3.type == 'MOTIVATE_VIDEO_HORIZONTAL' || this.form3.type == 'MOTIVATE_VIDEO_VERTICAL'">
                        <el-radio-group v-model="form3.motivate_video_autoplay">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>
                    </el-form-item>




                </el-form>

            </div>
        </el-main>
        <el-dialog title="选择创意样式" :visible.sync="createTypedialog" width="728px">
            <div class="el-form-item__content">
                <div class="style-selector">
                    <div class="category" v-for="category in styleCategories" :key="category.title">
                        <div class="category-title">{{ category.title }}</div>
                        <ul class="style-list">
                            <li v-for="style in category.styles" :key="style.value" :class="{
                                'selected': selectedStyle === style.value,
                                'recommended': style.recommended
                            }" @click="selectStyle(style)">
                                <!-- <div class="style-image"> -->
                                <img :src="style.image" class="bg-image">
                                <!-- </div> -->
                                <span class="style-info">{{ style.label }}</span>
                            </li>
                        </ul>
                        <div v-if="selectedStyle === 'reward_video_vertical'" class="style-tips">
                            激励视频(竖版): 通过激励性质大幅提升视频完播率，竖版全屏沉静式播放体验，带来更佳的转化效果！
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createTypedialog = false">取 消</el-button>
                <el-button type="primary" @click="CreativeTypechang">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="上传创意素材" :visible.sync="creativeMaterials" width="1160px" append-to-body>
            <div class="m-header" style="height: 600px;overflow-y: auto;" slot="title">
                <div class="m_header">
                    <el-tabs v-model="activeTab" type="card">
                        <el-tab-pane label="APP_LOGO" name="private">
                            <!-- 私有资源内容 -->
                            <div>APP_LOGO</div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="txfileList" :on-change="txhandleFileChange" :on-success="txhandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择头像素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>


                        </el-tab-pane>
                        <el-tab-pane label="图片" name="img">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ tpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    图片数量: {{ tpfileList.length }}
                                </div>
                                <el-button v-if="tpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllImages" class="clear-all-btn">
                                    清空全部
                                </el-button>
                            </div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="tpfileList" :on-change="tphandleFileChange" :on-success="tphandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="tphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="tphandleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                        </el-tab-pane>
                        <el-tab-pane label="视频封面" name="imgvideo">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ videotpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    封面图片数量: {{ videotpfileList.length }}
                                </div>
                                <el-button v-if="videotpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllcoverImages" class="clear-all-btn">
                                    清空全部
                                </el-button>

                            </div>
                            <div class="media-gallery">
                                <div class="media-item" v-for="(file, index) in videotpfileList"
                                    :key="file.uid || file.name || index">
                                    <div class="media-content">
                                        <!-- 缩略图 -->
                                        <img :src="file.url" alt="" class="media-thumbnail">

                                        <!-- 文件信息 -->
                                        <div class="file-info">
                                            <a class="file-name">
                                                <i class="el-icon-document"></i>
                                                {{ file.name }}
                                            </a>
                                            <label class="file-status">
                                                <i class="el-icon-check"></i>
                                            </label>
                                        </div>

                                        <!-- 操作按钮 -->
                                        <div class="media-actions">
                                            <span class="action-preview"
                                                @click.stop="videotphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="action-replace" @click.stop="handleReplaceFile(file, index)">
                                                <i class="el-icon-refresh"></i>
                                            </span>
                                            <span class="action-delete" @click.stop="videotphandleRemove(file)">
                                                <i class="el-icon-close"></i>
                                            </span>
                                        </div>

                                        <!-- 位置序号 -->
                                        <div class="position-index">第{{ index + 1 }}个</div>
                                    </div>
                                </div>
                            </div>
                            <el-upload ref="upload-videoimg" :multiple="true" action="#" list-type="picture-card"
                                scoped-slot="text" :file-list="videotpfileList" :on-change="videotphandleFileChange"
                                :show-file-list="false" :on-success="tphandleUploadSuccess" :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->


                            </el-upload>

                        </el-tab-pane>
                        <el-tab-pane label="视频" name="video">
                            <!-- 公共资源内容 -->
                            <div style="display: flex;align-items: center;margin-bottom: 20px;">
                                <div style="margin-right: 20px;">视频数量:{{ videofileList.length }} </div>

                                <el-button type="danger" icon="el-icon-delete" :disabled="selectedCount === 0"
                                    @click="deleteSelected" size="medium">
                                    删除选中 ({{ selectedCount }})
                                </el-button>
                                <el-button type="primary" plain icon="el-icon-delete" @click="deleteSelectedall"
                                    size="medium">
                                    清空素材
                                </el-button>
                                <div class="auto-cover-option">
                                    <el-checkbox v-model="autoGenerateCover" @change="handleAutoCoverChange">
                                        自动生成视频封面
                                    </el-checkbox>
                                    <el-tooltip content="开启后上传视频时会自动提取第一帧作为封面" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>

                            </div>

                            <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true"
                                ref="upload" :file-list="videofileList" :on-change="videohandleFileChange"
                                :show-file-list="false">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">
                                    将文件拖到此处，或<em>点击上传</em>
                                </div>
                                <div class="el-upload__tip" slot="tip">
                                    支持 MP4 格式
                                </div>


                            </el-upload>
                            <div class="video-list">
                                <div class="video-item" v-for="(file, index) in videofileList"
                                    :key="file.uid || file.name || index">
                                    <div class="video-content">
                                        <div class="selection-checkbox">
                                            <input type="checkbox" :checked="file.selected"
                                                @click.stop="toggleSelect(file)">
                                        </div>
                                        <span class="video-title">{{ file.name }}</span>
                                        <div class="video-thumbnail">
                                            <video :src="file.url" controls></video>
                                        </div>
                                        <el-button type="text" icon="el-icon-delete" @click="handleRemove2(file)"
                                            class="delete-btn"></el-button>
                                    </div>
                                </div>
                            </div>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>


        </el-dialog>
        <el-dialog :visible.sync="dialogVisible" width="70%">
            <img width="100%" height="70%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="任务执行列表" :visible.sync="opencreatedanyuanliststatus" width="1000px" :close-on-click-modal="false">
            <div class="task-list-container">
                <div v-for="task in tasks" :key="task.id" class="task-card">
                    <!-- 主任务头部 -->
                    <div class="task-header">
                        <div class="task-title">
                            <el-tag size="small" :type="getStatusType(task.status)" class="task-tag">
                                {{ getStatusText(task.status) }}
                            </el-tag>
                            <span class="task-name">{{ task.name }}</span>
                        </div>
                        <div class="task-meta">
                            <span class="task-progress">{{ task.currentIndex }}/{{ task.totalItems }}</span>
                            <span class="task-time">{{ task.createdAt }}</span>
                            <div class="task-actions">
                                <el-button v-if="task.status === 'running'" @click="stopTask(task.id)" size="mini"
                                    type="warning" plain>
                                    停止
                                </el-button>
                                <el-button v-if="['stopped', 'failed', 'done', 'error'].includes(task.status)"
                                    @click="deleteTask(task.id)" size="mini" type="danger" plain>
                                    删除
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 用户任务列表 -->
                    <div class="user-tasks-container">
                        <div v-for="(user, userIndex) in task.userDetails" :key="userIndex" class="user-task-item">
                            <div class="user-header">
                                <div class="user-info">
                                    <strong class="user-account-name">{{ user.accountName }}</strong>
                                    <span class="user-campaign">({{ user.campaignName }})</span>
                                    <el-tag size="mini" :type="getStatusType(user.status)" class="user-status-tag">
                                        {{ getStatusText(user.status) }}
                                    </el-tag>
                                </div>
                            </div>

                            <!-- 用户步骤时间线 -->
                            <div class="user-steps-timeline">
                                <div v-for="(step, stepIndex) in user.steps" :key="stepIndex"
                                    :class="['user-timeline-item', `status-${step.status}`]">
                                    <div class="user-timeline-marker">
                                        <div :class="['user-marker-icon', step.status]">
                                            <i v-if="step.status === 'wait'" class="el-icon-time"></i>
                                            <i v-else-if="step.status === 'doing'" class="el-icon-loading"></i>
                                            <i v-else-if="step.status === 'success'" class="el-icon-success"></i>
                                            <i v-else-if="step.status === 'error'" class="el-icon-error"></i>
                                        </div>
                                        <div class="user-timeline-connector" v-if="stepIndex < user.steps.length - 1"></div>
                                    </div>

                                    <div class="user-timeline-content">
                                        <div class="user-step-header">
                                            <span class="user-step-name">{{ step.name }}</span>
                                            <el-tag size="mini" :type="getStepStatusType(step.status)"
                                                class="user-step-status">
                                                {{ getStepStatusText(step.status) }}
                                            </el-tag>
                                        </div>
                                        <div class="user-step-detail" v-if="step.detail">
                                            {{ step.detail }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 创意列表 -->
                            <div v-if="user.creatives && user.creatives.length" class="creative-list">
                                <div class="creative-title">
                                    <span>创意列表 ({{ user.creatives.length }}条)</span>
                                    <el-tag size="mini" type="info">
                                        成功: {{ user.creatives.filter(c => c.status === 'done' || c.status ===
                                            'success').length }} /
                                        失败: {{ user.creatives.filter(c => c.status === 'failed' || c.status ===
                                            'error').length }} /
                                        总计: {{ user.creatives.length }}
                                    </el-tag>
                                </div>
                                <div v-for="(creative, creativeIndex) in user.creatives" :key="creativeIndex"
                                    :class="['creative-item', `creative-status-${creative.status}`]">
                                    <div class="creative-header">
                                        <div class="creative-info">
                                            <span class="creative-id">创意 #{{ creative.id }}</span>
                                            <el-tag size="mini" :type="getStatusType(creative.status)"
                                                class="creative-status">
                                                {{ getStatusText(creative.status) }}
                                            </el-tag>
                                        </div>
                                    </div>

                                    <div class="creative-steps">
                                        <div v-for="(step, stepIndex) in creative.steps" :key="stepIndex"
                                            :class="['creative-step', `step-${step.status}`]">
                                            <div class="creative-step-marker">
                                                <div :class="['creative-marker', step.status]">
                                                    <i v-if="step.status === 'wait'" class="el-icon-time"></i>
                                                    <i v-else-if="step.status === 'doing'" class="el-icon-loading"></i>
                                                    <i v-else-if="step.status === 'success'" class="el-icon-success"></i>
                                                    <i v-else-if="step.status === 'error'" class="el-icon-error"></i>
                                                </div>
                                            </div>
                                            <div class="creative-step-content">
                                                <span class="creative-step-name">{{ step.name }}</span>
                                                <el-tag size="mini" :type="getStepStatusType(step.status)"
                                                    class="creative-step-status">
                                                    {{ getStepStatusText(step.status) }}
                                                </el-tag>
                                                <span class="creative-step-detail" v-if="step.detail">{{ step.detail
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 空状态 -->
                <div v-if="tasks.length === 0" class="empty-state">
                    <el-empty description="暂无执行任务" />
                </div>
            </div>
        </el-dialog>
        <div class="adgroup-footer">

            <!-- <el-button type="primary" @click="createsucai">
                上传素材
            </el-button> -->

            <el-button type="primary" @click="startBatchTasks">
                开始搭建
            </el-button>

            <el-button type="primary" @click="opencreatedanyuanlist" v-if="tasks.length > 0">
                查看任务进度
            </el-button>

            <div style="width: 300px;margin-left: 40px;" v-if="showProgress">
                <el-progress :percentage="uploadPercent" :text-inside="false" :color="customColors" :stroke-width="4"
                    style="" />
            </div>

        </div>
    </el-container>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
export default {
    data() {
        return {
            taskControllers: new Map(), // 任务控制器存储
            isTaskStopped: new Map(), // 任务停止状态
            videotpfileListcode: [],
            videotpfileList: [],
            opencreatedanyuanliststatus: false,
            tasks: [], // 所有任务列表
            taskIdCounter: 1, // 自增 ID
            autoGenerateCover: true,
            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            showProgress: false,
            uploadPercent: 0,
            records: [],
            dingxiangbao: [],
            ids_list: [],
            selectedValue: [],
            selectedValue2: [],
            options: [], // 初始化空数组
            cascaderProps: {
                value: 'value',
                label: 'label',
                children: 'children',
                checkStrictly: false, // 如果需要严格模式
                multiple: true,
                emitPath: false
            },
            audience_list: [],
            btgjc: "",
            form: {

                optimization_goal: 'APPLICATION_DOWNLOAD',       // 默认选中应用推广
                app_marketing_type: 'ACTIVATION',  // 营销场景
                campaign_name: '',              // 广告计划名称
                dateRange: [],         // 投放日期范围
                budget: '',            // 投放预算
                budgetStatus: '1',      // 默认关闭明日投放预算
                audienceOrient: 1, // 默认选中自定义
                audienceOrienttGroup: [],
                audienceOrientFilter: "",
                osType: "COMMON",
                appPackage: "DISABLE",
                appPackageValue: "",
                appFilter: "DISABLE",
                appFilterValue: ""
            },
            conversion_goal_group: [
                { value: "ACTIVATION", label: "激活" },
                { value: "REGISTER", label: "注册" },
                { value: "CHARGE", label: "付费" },
                { value: "FIRST_ACTIVATION", label: "首次拉活" },
                { value: "EFFECTIVE_READING", label: "有效阅读" },
                { value: "QAPP_ADD_DESK", label: "快应用添加至桌面" },
                { value: "API_APP_KEYACTION", label: "关键行为" },
            ],

            optimization_goal_group: [
                { value: "LANDING_PAGE_URL", label: "线索收集" },
                { value: "APPLICATION_DOWNLOAD", label: "应用推广" },
                { value: "MINI_PROGRAM", label: "微信小程序" },
                { value: "QUICK_APP", label: "快应用" },
            ],
            deep_conversion_goal_group: [
                { value: "NO", label: "无" },
                { value: "RETENTION", label: "次日留存" },
                { value: "TWO_RETENTION", label: "二留" },
                { value: "SIX_RETENTION", label: "六留" },
                { value: "CHARGE", label: "付费" },
                { value: "KEY_ACTION", label: "关键行为" },
            ],
            form2: {
                transfer_optimize: "DEFAULT",
                ocpx_expand: 'DISABLE',
                dingxiangbao: '',
                plan: '',
                adgroup_name: '',
                audience_orient_filter: [],
                audience_orient: [],
                mediaType: 'OPTIMIZATION',
                selectedMedia: ['QTT', 'MIDU', 'QUMENG'],
                // selectedMedia: ['QTT', 'MIDU', 'QUMENG', 'GAMES'],
                adSlotType: 'COMMON',
                selectedAdSlots: ['NEWSFEED_LIST', 'NEWSFEED_DETAIL', 'ENGAGEMENT', 'OPEN_SCREEN'
                    , 'BANNER',
                ],//'MOTIVATE_APP'
                regionType: 'COMMON',
                regionSearch: '',
                selectedRegions: [],
                gender: 'COMMON',
                ageType: 'ALL',
                selectedAges: ["COMMON"],
                phonePriceType: 'ALL',
                selectedPhonePrices: ["COMMON"],
                networkType: 'ALL',
                selectedNetworks: ["COMMON"],
                timeType: 'COMMON',
                timeRangeType: '1',
                selectedTimes: [],
                showFrequency: 3,
                clickFrequency: 1,
                bidPrice: '',
                conversionFrom: 'API',
                cpaBid: '',
                chargeType: 'CPC',
                retentionRate: '',
                deepConversionGoal: "NO",
                deepCpaBid: '',
                conversionGoal: 'FIRST_ACTIVATION',
                selectedDays: [true, true, true, true, true, false, false], // 默认选中工作日
                selectedHours: Array(7).fill().map(() => Array(24).fill(false))
            },
            transfer_optimize_group: [
                { value: "DEFAULT", label: "无" },
                { value: "LOW", label: "低强度" },
                { value: "MIDDLE", label: "中强度" },
                { value: "HIGH", label: "高强度" },

            ],
            weekDays: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
            isSelecting: false,
            selectionStart: null,
            material_type: "",
            titlesString: '',
            titlesString2: '',
            titlesString3: '',
            titlesString4: '',
            titlesString5: '',
            titlesString6: '',
            titlesString7: '',
            titlesString8: '',
            titlesString11: '',
            form3: {
                plan: '',
                creativeName: "",
                type: "",
                sub_cate: "ANDROID_APP",
                conversion_type: "DEFAULT",
                download_url: "",
                deep_link: "",
                target_url_h5: "",
                app_name: "",
                app_logo: "",
                title: [],
                second_title: [],
                app_introduction: [],
                app_desc: [],
                click_feedback_url: '',
                play_action: '',
                play_duration: '',
                motivate_video_autoplay: 'DISABLE',
                description: [],
                text_link_description: [],
                text_link_btn: [],
                btn_text: [],
                number: null
            },
            playActionOptions: [{
                value: 'TRY',
                label: '试玩'
            }, {
                value: 'READ',
                label: '阅读'
            }, {
                value: 'USE',
                label: '使用'
            }, {
                value: 'REVIEW',
                label: '浏览'
            }, {
                value: 'REGISTER_AND_TRY',
                label: '注册并试玩'
            }],
            playDurationOptions: [{
                value: 'ONE_MINUTE',
                label: '1分钟'
            }, {
                value: 'TWO_MINUTES',
                label: '2分钟'
            }, {
                value: 'THREE_MINUTES',
                label: '3分钟'
            }],
            creativeMaterials: false, //素材
            txfileList: [],
            txfileCode: [],
            dialogImageUrl: '',
            activeTab: 'private',
            txuploadDialogVisible: false,
            txList: [],
            txuploading: false,
            dialogVisible: false,
            tpfileList: [],
            tpfileListcode: [],
            tpuploadDialogVisible: false,
            videofileList: [],
            selectedStyle: 'reward_video_vertical',
            styleCategories: [
                {
                    title: '视频类',
                    styles: [
                        {
                            value: 'MOTIVATE_VIDEO_VERTICAL',
                            label: '激励视频(竖版)',
                            image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                            recommended: true
                        },
                        {
                            value: 'MOTIVATE_VIDEO_HORIZONTAL',
                            label: '激励视频(横版)',
                            image: 'https://demo.nbweiou.cn/img/02.png'
                        },
                        {
                            value: 'VIDEO_VERTICAL',
                            label: '视频广告(竖版)',
                            image: 'https://demo.nbweiou.cn/img/03.png'
                        },
                        {
                            value: 'VIDEO_HORIZONTAL',
                            label: '视频广告(横版)',
                            image: 'https://demo.nbweiou.cn/img/04.png'
                        }
                    ]
                },
                {
                    title: '图文类',
                    styles: [
                        {
                            value: 'SMALL_IMAGE',
                            label: '小图',
                            image: 'https://demo.nbweiou.cn/img/05.png'
                        },
                        {
                            value: 'BIG_IMAGE',
                            label: '大图',
                            image: 'https://demo.nbweiou.cn/img/06.png'
                        },
                        // {
                        //     value: 'GROUP_IMAGE',
                        //     label: '组图',
                        //     image: 'https://demo.nbweiou.cn/img/07.png'
                        // },
                        // {
                        //     value: 'TEXT_LINK',
                        //     label: '文字链',
                        //     image: 'https://demo.nbweiou.cn/img/08.png'
                        // },
                        // {
                        //     value: 'ENGAGEMENT',
                        //     label: '互动广告',
                        //     image: 'https://demo.nbweiou.cn/img/09.png'
                        // },
                        {
                            value: 'OPEN_SCREEN',
                            label: '开屏广告',
                            image: 'https://demo.nbweiou.cn/img/10.png'
                        },
                        // {
                        //     value: 'BANNER',
                        //     label: '横幅广告',
                        //     image: 'https://demo.nbweiou.cn/img/11.png'
                        // },
                        // {
                        //     value: 'MOTIVATE_APP',
                        //     label: '应用商城',
                        //     image: 'https://demo.nbweiou.cn/img/12.png'
                        // }
                    ]
                }
            ],
            planOptions: [
                { value: '5436420', label: '0523n(5436420)(应用推广)' },
                { value: '5434754', label: '掐指一算(5434754)(应用推广)' },
                { value: '5434162', label: 'gogogo(5434162)(应用推广)' },
                { value: '5434148', label: '888(5434148)(应用推广)' },
                { value: '5434040', label: '666(5434040)(应用推广)' },
                { value: '5420981', label: '0521(5420981)(应用推广)' },
                { value: '5418267', label: '新的广告计划(5418267)(应用推广)' }
            ],
            mediaOptions: [
                { value: 'QTT', label: '趣头条' },
                { value: 'MIDU', label: '米读' },
                { value: 'QUMENG', label: '趣盟' },
                // { value: 'GAMES', label: '发行游戏' }
            ],
            adSlotOptions: [
                { value: 'NEWSFEED_LIST', label: '信息流列表页' },
                { value: 'NEWSFEED_DETAIL', label: '信息流详情页' },
                { value: 'ENGAGEMENT', label: '互动广告' },
                { value: 'OPEN_SCREEN', label: '开屏广告' },
                { value: 'BANNER', label: '横幅广告' },
                // { value: 'MOTIVATE_APP', label: '应用商城' },
            ],
            regionOptions: [
                { value: 'SHANGHAI', label: '上海' },
                { value: 'BEIJING', label: '北京' },
                { value: 'GUANGDONG', label: '广东' },
                { value: 'ZHEJIANG', label: '浙江' }
            ],
            ageOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'AGE_STATE_ONE', label: '18岁以下' },
                { value: 'AGE_STATE_TWO', label: '18-24岁' },
                { value: 'AGE_STATE_THREE', label: '25-30岁' },
                { value: 'AGE_STATE_FOUR', label: '31-40岁' },
                { value: 'AGE_STATE_FIVE', label: '41-50岁' },
                { value: 'AGE_STATE_SIX', label: '51-60岁' },
                { value: 'AGE_STATE_SEVEN', label: '61岁以上' }
            ],
            phonePriceOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'HIGH', label: '高端' },
                { value: 'MIDDLE', label: '中高端' },
                { value: 'MIDDLE_AND_LOW', label: '中低端' },
                { value: 'LOW', label: '低端' }
            ],
            networkOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'WIFI', label: 'WIFI' },
                { value: '2G', label: '2G' },
                { value: '3G', label: '3G' },
                { value: '4G', label: '4G' },
                { value: '5G', label: '5G' }
            ],
            checkAll: true,
            isIndeterminate: false,
            adSlotisIndeterminate: false,
            adSlotcheckAll: true,
            createTypedialog: false,
            selectedStylelabel: "",
            restaurants: ["淘宝", "美团", "支付宝", "闲鱼", "抖音商城"],
            allRestaurants: [],
            linesWithLimitError: [],
            linesWithLimitError2: [],
            startDate: '',
            endDate: '',
            campaign_id: '',
            videofileListcode: [],
            userId: '',
            logList: [],
            replacingIndex: null,
            mixminvaluelate: '轮询',
            currentIndeximg: 0,
            currentIndexvideo: 0,
            currentIndextext: 0,
            copycurrentIndextext: 0
        };
    },
    created() {

        this.userId = this.$route.query.userId

        if (!this.userId) {
            // 使用Element UI的消息提示
            this.$message.warning('您得先登录')

            // 设置延迟跳转让用户看到提示
            setTimeout(() => {
                // 重定向到登录页面（外部链接）
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)  // 1.5秒后跳转

            // 终止后续执行
        }
        // else {
        //     // 如果获取到userId则正常加载
        //     this.loadTemplates(1)
        // }

        this.handlelistByUbs()
        this.getdingxiangbao()
        this.updateCheckAllState
        this.allRestaurants = this.restaurants.map(item => {
            return { value: item }
        })

        const apiData = {
            "audience_list": [this.audience_list], // 你的原始数据
            "category_id": 25,
            "category_name": "dmp推荐人群",
            "type": 3
        };

        // 转换数据结构

    },
    computed: {
        // 计算选中的视频数量
        selectedCount() {
            return this.videofileList.filter(file => file.selected).length;
        }
    },
    watch: {
        // 监听选中项变化
        'form2.selectedMedia': {
            handler(val) {
                console.log(val);
                this.updateCheckAllState();
            },
            deep: true
        }
    },
    methods: {
        relist() {
            this.userId = this.$route.query.userId
            if (!this.userId) {
                this.$message.warning('您得先登录')
                setTimeout(() => {
                    window.location.href = 'https://control.zjwec.cn/page/end/login.html'
                }, 1500)
            }
  
            this.btgjc=""
            this.handlelistByUbs()
            this.getdingxiangbao()
        },
        getBuildDescriptionIndexes(countPerBuild) {
            let res = this.titlesString5
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
            if (!res.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndextext + i) % res.length;
                indexes.push(index);
            }

            this.currentIndextext = (this.currentIndextext + countPerBuild) % res.length;

            return indexes;
        },
        getBuildtextIndexes(countPerBuild) {
            let res = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
            if (!res.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndextext + i) % res.length;
                indexes.push(index);
            }

            this.currentIndextext = (this.currentIndextext + countPerBuild) % res.length;

            return indexes;
        },
        copygetBuildtextIndexes(countPerBuild) {
            let res = this.titlesString2
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
            if (!res.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.copycurrentIndextext + i) % res.length;
                indexes.push(index);
            }

            this.copycurrentIndextext = (this.copycurrentIndextext + countPerBuild) % res.length;

            return indexes;
        },
        getBuildvideoIndexes(countPerBuild) {
            if (!this.videofileList.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndexvideo + i) % this.videofileList.length;
                indexes.push(index);
            }

            this.currentIndexvideo = (this.currentIndexvideo + countPerBuild) % this.videofileList.length;

            return indexes;
        },
        getBuildIndexes(countPerBuild) {
            if (!this.tpfileList.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                const index = (this.currentIndeximg + i) % this.tpfileList.length;
                indexes.push(index);
            }

            this.currentIndeximg = (this.currentIndeximg + countPerBuild) % this.tpfileList.length;

            return indexes;
        },
        handleReplaceFile(file, index) {
            // 设置当前要替换的文件索引
            this.replacingIndex = index;

            // 使用新的 ref 名称
            this.$refs['upload-videoimg'].$el.querySelector('.el-upload--picture-card').click();
        },

        videotphandleFileChange(newFile, fileList) {
            // 如果有正在替换的文件
            if (this.replacingIndex !== undefined && this.replacingIndex !== null) {
                // 替换指定位置的文件
                this.videotpfileList.splice(this.replacingIndex, 1, {
                    ...newFile,
                    url: newFile.url || URL.createObjectURL(newFile.raw),
                    uid: Date.now()
                });

                // 重置替换索引
                this.replacingIndex = null;
            } else {
                // 正常的添加文件逻辑
                this.videotpfileList = fileList.map(f => ({
                    ...f,
                    url: f.url || URL.createObjectURL(f.raw)
                }));
            }
        },

        // 上传成功后的回调
        onUploadSuccess(response, file) {
            if (this.videotpfileList.length > 0) {
                // 替换第一个文件
                this.videotpfileList.splice(0, 1, file);
            } else {
                // 如果没有文件，则添加
                this.videotpfileList.push(file);
            }
        },
        tphandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        videotphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        videotphandleRemove(file) {
            this.videotpfileListcode = []
            const tp = this.videotpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videotpfileList.splice(tp, 1);
            }
            console.log(this.videotpfileList);
            console.log(this.videotpfileListcode);
        },
        startBatchTasks() {
            const id = this.taskIdCounter++;
            const newTask = {
                id,
                name: `批量任务 #${id} - ${this.ids_list.length}个账户`,
                status: 'waiting',
                createdAt: new Date().toLocaleString(),
                currentIndex: 0,
                totalItems: this.ids_list.length,
                // 添加用户详情信息
                userDetails: this.ids_list.map(user => ({
                    accountName: user.accountName,
                    campaignName: user.campaignName,
                    accountId: user.accountId,
                    status: 'waiting',
                    steps: [
                        { name: '创建计划', status: 'wait', detail: null },
                        { name: '创建广告单元', status: 'wait', detail: null },
                        { name: '上传LOGO', status: 'wait', detail: null },
                        { name: '上传素材', status: 'wait', detail: null },
                        { name: '创建创意', status: 'wait', detail: null },
                        { name: '完成', status: 'wait', detail: null },
                    ],
                    creatives: [] // 新增创意列表
                })),
                steps: [
                    { name: '批量处理', status: 'wait', detail: null },
                    { name: '完成', status: 'wait', detail: null },
                ],
            };
            this.tasks.unshift(newTask);
            this.$nextTick(() => this.createdanyuan(id));
        },

        setStep(taskId, userIndex, stepIndex, status, detail = null) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            // 如果 userIndex 为 null，更新主任务步骤
            if (userIndex === null) {
                const step = task.steps[stepIndex];
                if (!step) return;
                step.status = status;
                step.detail = this.formatDetail(detail);
            } else {
                // 更新用户步骤
                const user = task.userDetails[userIndex];
                if (!user || !user.steps) return;

                const step = user.steps[stepIndex];
                if (!step) return;
                step.status = status;
                step.detail = this.formatDetail(detail);

                // 更新用户状态
                if (status === 'doing') user.status = 'running';
                if (status === 'error') user.status = 'failed';
                if (user.steps.every(s => s.status === 'success')) user.status = 'done';
            }

            // 更新主任务状态
            if (status === 'doing') task.status = 'running';
            if (status === 'error') task.status = 'failed';
            if (task.userDetails.every(u => u.status === 'done')) task.status = 'done';
        },

        // 辅助方法
        formatDetail(detail) {
            if (!detail) return '';
            if (typeof detail === 'string') return detail;
            return JSON.stringify(detail);
        },


        formatDetail(detail) {
            if (detail === undefined || detail === null) {
                return null;
            } else if (typeof detail === 'string') {
                return detail;
            } else {
                try {
                    return typeof detail === 'object' ? JSON.stringify(detail) : String(detail);
                } catch (e) {
                    return String(detail);
                }
            }
        },
        opencreatedanyuanlist() {
            this.opencreatedanyuanliststatus = true
        },
        // async createsucai() {
        //     console.log(this.material_type);
        //     for (let key = 0; key < this.ids_list.length; key++) {
        //         for (let index = 0; index < this.videofileList.length; index++) {
        //             await this.uploadImgFile3(this.videofileList[index], this.ids_list[key], this.material_type)

        //              if(this.tpfileList.length > 0) await this.uploadImgFile4(this.tpfileList[index], this.ids_list[key], this.form3.type)
        //         }
        //         if (this.tpfileList.length > 0) {
        //             for (let index = 0; index < this.tpfileList.length; index++) {

        //                 if(this.videofileList.length > 0) await this.uploadImgFile3(this.videofileList[index], this.ids_list[key], this.material_type)

        //                 await this.uploadImgFile4(this.tpfileList[index], this.ids_list[key], this.form3.type)
        //             }
        //         }
        //     }
        // },
        clearAllImages() {
            this.tpfileList = [];
            this.$message.success('已清空所有图片');
        },
        deleteSelectedall() { this.videofileList = []; },
        toggleSelect(file) {
            this.$set(file, 'selected', !file.selected);
        },

        // 删除选中的视频
        deleteSelected() {
            this.videofileList = this.videofileList.filter(file => !file.selected);
        },
        form3Numberchange(str) {
            console.log(str);

        },
        async getdingxiangbao() {
            await axios.get(`https://control.zjwec.cn/rgionPgk/list?userid=${this.userId}`).then(res => {
                // console.log(res.data);
                this.dingxiangbao = res.data.data
            })
        },
        async cydj(key, campaign_id, adgroup_id, taskuserlist, taskId, signal) {
            const set = (userIndex, stepIndex, status, detail) =>
                this.setStep(taskId, userIndex, stepIndex, status, detail);

            try {
                // 初始化创意日志结构
                this.initCreativeLogs(taskId, key, this.form3.number);
                console.log(this.tasks);

                this.tpfileListcode = []
                this.videofileListcode = []
                this.videotpfileListcode = []
                console.log('开始处理用户:', key);

                // 步骤2：上传LOGO
                set(key, 2, 'doing', '上传应用LOGO中...');
                if (!this.txfileList.length > 0) {
                    this.$message.warning("请上传头像!!")
                    set(key, 2, 'error', '未上传LOGO');
                    return
                }

                // 检查任务是否停止
                if (signal.aborted) throw new Error('任务中止');

                let sucairesult = await this.uploadImgFile(this.txfileList[0].file, "LOGO", taskuserlist[key])
                set(key, 2, 'success', 'LOGO上传成功');

                // 视频类型创意处理
                if (this.form3.type == 'MOTIVATE_VIDEO_VERTICAL' || this.form3.type == 'MOTIVATE_VIDEO_HORIZONTAL' || this.form3.type == 'VIDEO_HORIZONTAL' || this.form3.type == 'VIDEO_VERTICAL') {
                    await this.processVideoCreatives(key, campaign_id, adgroup_id, taskuserlist, taskId, sucairesult, signal);
                } else {
                    // 非视频类型创意处理
                    await this.processImageCreatives(key, campaign_id, adgroup_id, taskuserlist, taskId, sucairesult, signal);
                }

                // 步骤5：完成
                set(key, 5, 'success', '用户搭建完成');

            } catch (error) {
                if (error.name === 'AbortError') {
                    set(key, 4, 'error', '创意创建过程被中止');
                } else {
                    set(key, 4, 'error', `创意创建过程异常: ${error.message}`);
                    console.error('cydj error:', error);
                }
            }
        },

        // 处理视频创意
        async processVideoCreatives(key, campaign_id, adgroup_id, taskuserlist, taskId, sucairesult, signal) {
            const set = (userIndex, stepIndex, status, detail) =>
                this.setStep(taskId, userIndex, stepIndex, status, detail);

            let videoarray = this.getBuildvideoIndexes(this.form3.number)
            console.log('视频素材索引:', videoarray);

            let description, secondTitlelist, titlelist;

            // 验证必要字段
            if (this.form3.type == 'MOTIVATE_VIDEO_VERTICAL' || this.form3.type == 'MOTIVATE_VIDEO_HORIZONTAL') {
                if (!this.form3.description.length > 0) {
                    this.$message.warning("必传：创意描述为空！！")
                    set(key, 3, 'error', '创意描述为空');
                    return
                }
                description = this.getBuildDescriptionIndexes(this.form3.number)
            } else if (this.form3.type == 'VIDEO_VERTICAL' || this.form3.type == 'VIDEO_HORIZONTAL') {
                if ((!this.form3.title.length > 0) || (!this.form3.second_title.length > 0)) {
                    this.$message.warning("必传：标题/副标题为空！！")
                    set(key, 3, 'error', '标题/副标题为空');
                    return
                }
                titlelist = this.getBuildtextIndexes(this.form3.number)
                secondTitlelist = this.copygetBuildtextIndexes(this.form3.number)
            }

            for (let index = 0; index < this.form3.number; index++) {
                // 检查任务是否停止
                if (signal.aborted) throw new Error('任务中止');

                // 设置创意步骤状态
                this.setCreativeStep(taskId, key, index, 0, 'success', 'LOGO上传完成');
                this.setCreativeStep(taskId, key, index, 1, 'doing', '开始上传素材...');

                console.log('处理视频创意类型:', this.form3.type);

                // 步骤3：上传素材
                set(key, 3, 'doing', `上传视频素材 ${index + 1}/${this.videofileList.length}...`);

                let videoUploadSuccess = false;
                let coverUploadSuccess = false;
                let retryCount = 0;
                const maxRetries = 3;

                // 视频上传逻辑（支持重试）
                while (!videoUploadSuccess && retryCount < maxRetries) {
                    try {
                        await this.uploadImgFile3(this.videofileList[videoarray[index]], taskuserlist[key], this.material_type)
                        videoUploadSuccess = true;
                        this.setCreativeStep(taskId, key, index, 1, 'doing', `视频素材 ${index + 1} 上传成功`);
                    } catch (error) {
                        retryCount++;
                        console.error(`视频素材上传失败 (尝试 ${retryCount}/${maxRetries}): ${error.message}`);

                        if (retryCount < maxRetries) {
                            // 前两次失败，只重试不删除素材
                            this.setCreativeStep(taskId, key, index, 1, 'doing', `视频素材上传失败，正在重试 (${retryCount}/${maxRetries})...`);
                            // 继续循环重试
                        } else {
                            // 第三次失败时才删除素材
                            console.log("第三次失败，删除对应素材", this.videofileList);
                            console.log("第三次失败，删除对应素材", this.videotpfileList);
                            this.removeFailedMaterial(videoarray[index], 'video');
                            // this.removeFailedMaterial(videoarray[index], 'cover');
                            console.log(this.videofileList);
                            console.log(this.videotpfileList);

                            // 重新计算索引数组
                            videoarray = this.getBuildvideoIndexes(this.form3.number);
                            console.log(`删除视频后重新计算的索引:`, videoarray);

                            this.setCreativeStep(taskId, key, index, 1, 'error', `视频素材上传失败: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', '因素材上传失败，跳过创意创建');
                            continue; // 跳过当前创意，继续下一个
                        }
                    }
                }

                // 如果视频上传失败，跳过当前创意
                if (!videoUploadSuccess) {
                    continue;
                }

                set(key, 3, 'doing', `上传图片素材 ${index + 1}/${this.tpfileList.length}...`);

                // 封面上传逻辑（支持重试）
                retryCount = 0; // 重置重试计数
                while (!coverUploadSuccess && retryCount < maxRetries) {
                    try {
                        await this.uploadImgFile5(this.videotpfileList[videoarray[index]], taskuserlist[key], this.form3.type)
                        coverUploadSuccess = true;
                        this.setCreativeStep(taskId, key, index, 1, 'doing', `图片素材 ${index + 1} 上传成功`);
                    } catch (error) {
                        retryCount++;
                        console.error(`图片素材上传失败 (尝试 ${retryCount}/${maxRetries}): ${error.message}`);

                        // 上传失败时删除对应素材
                        this.removeFailedMaterial(videoarray[index], 'cover');

                        // 重新计算索引数组
                        videoarray = this.getBuildvideoIndexes(this.form3.number);
                        console.log(`删除封面后重新计算的索引 (尝试 ${retryCount}):`, videoarray);

                        if (retryCount < maxRetries) {
                            this.setCreativeStep(taskId, key, index, 1, 'doing', `图片素材上传失败，正在重试 (${retryCount}/${maxRetries})...`);
                            // 继续循环，用新的 videoarray 重新尝试
                        } else {
                            this.setCreativeStep(taskId, key, index, 1, 'error', `图片素材上传失败: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', '因素材上传失败，跳过创意创建');
                            continue; // 跳过当前创意，继续下一个
                        }
                    }
                }

                // 如果封面上传失败，跳过当前创意
                if (!coverUploadSuccess) {
                    continue;
                }

                // 如果素材上传都成功，继续创建创意
                if (videoUploadSuccess && coverUploadSuccess) {
                    set(key, 3, 'success', '素材上传完成');
                    this.setCreativeStep(taskId, key, index, 1, 'success', '所有素材上传完成');

                    let app_logo = sucairesult.data.remote_url
                    let data3 = {
                        campaign_id: campaign_id,
                        adgroup_id,
                        creative_name: this.form3.creativeName,
                        type: this.form3.type,
                        app_logo,
                        app_name: this.form3.app_name
                    }

                    if (this.form3.type == 'MOTIVATE_VIDEO_VERTICAL' || this.form3.type == 'MOTIVATE_VIDEO_HORIZONTAL') {
                        data3 = {
                            ...data3,
                            image: [this.videotpfileListcode[index]],
                            video_id: this.videofileListcode[index],
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            motivate_video_autoplay: this.form3.motivate_video_autoplay,
                            click_feedback_url: taskuserlist[key].clickMonitorUrl,
                            description: this.form3.description[description[index]]
                        }
                        data3 = this.removeEmptyFields(data3)

                        // 步骤4：创建创意
                        set(key, 4, 'doing', `创建激励视频创意 ${index + 1}...`);
                        this.setCreativeStep(taskId, key, index, 2, 'doing', '创建激励视频创意中...');

                        try {
                            let creativeRes = await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                                },
                                params: {
                                    account_id: taskuserlist[key].accountId
                                },
                                signal: signal
                            });

                            if (creativeRes.data.code == 400) {
                                set(key, 4, 'error', `激励视频创意创建失败: ${creativeRes.data.message}`);
                                this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${creativeRes.data.message}`);
                                this.$message({
                                    showClose: true,
                                    message: creativeRes.data.message
                                });
                                continue;
                            }
                            if (creativeRes.data.code == 200) {
                                set(key, 4, 'success', `激励视频创意创建成功，创意ID: ${creativeRes.data.data.creative_id || '未知ID'}`);
                                this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${creativeRes.data.data.creative_id || '未知ID'}`);
                                this.$message.success("激励视频创意搭建成功")
                            }
                        } catch (error) {
                            if (error.name === 'AbortError') throw error;
                            set(key, 4, 'error', `激励视频创意创建异常: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                        }

                    } else if (this.form3.type == 'VIDEO_VERTICAL' || this.form3.type == 'VIDEO_HORIZONTAL') {
                        data3 = {
                            ...data3,
                            image: [this.videotpfileListcode[index], sucairesult.data.id],
                            video_id: this.videofileListcode[index],
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            title: this.form3.title[titlelist[index]],
                            second_title: this.form3.second_title[secondTitlelist[index]],
                            click_feedback_url: taskuserlist[key].clickMonitorUrl
                        }
                        data3 = this.removeEmptyFields(data3)

                        // 步骤4：创建创意
                        set(key, 4, 'doing', `创建视频创意 ${index + 1}...`);
                        this.setCreativeStep(taskId, key, index, 2, 'doing', '创建视频创意中...');

                        try {
                            let creativeRes = await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                                },
                                params: {
                                    account_id: taskuserlist[key].accountId
                                },
                                signal: signal
                            });

                            if (creativeRes.data.code == 400) {
                                set(key, 4, 'error', `视频创意创建失败: ${creativeRes.data.message}`);
                                this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${creativeRes.data.message}`);
                                this.$message({
                                    showClose: true,
                                    message: creativeRes.data.message
                                });
                                continue;
                            }
                            if (creativeRes.data.code == 200) {
                                set(key, 4, 'success', `视频创意创建成功，创意ID: ${creativeRes.data.data.creative_id || '未知ID'}`);
                                this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${creativeRes.data.data.creative_id || '未知ID'}`);
                                this.$message.success("视频创意搭建成功")
                            }
                        } catch (error) {
                            if (error.name === 'AbortError') throw error;
                            set(key, 4, 'error', `视频创意创建异常: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                        }
                    }
                }
            }
        },
        async processImageCreatives(key, campaign_id, adgroup_id, taskuserlist, taskId, sucairesult, signal) {
            const set = (userIndex, stepIndex, status, detail) =>
                this.setStep(taskId, userIndex, stepIndex, status, detail);

            let imglist = this.getBuildIndexes(this.form3.number)
            let textTitle, secondTitle;

            if (this.form3.type == 'SMALL_IMAGE' || this.form3.type == 'BIG_IMAGE') {
                if ((!this.form3.title.length > 0)) {
                    this.$message.warning("必传：标题为空！！")
                    set(key, 3, 'error', '标题为空');
                    return
                }
                textTitle = this.getBuildtextIndexes(this.form3.number)
                if (this.form3.second_title.length > 0) {
                    secondTitle = this.copygetBuildtextIndexes(this.form3.number)
                }
            }


            // 非视频类型的创意
            for (let index = 0; index < this.form3.number; index++) {
                // 检查任务是否停止
                if (signal.aborted) throw new Error('任务中止');

                // 设置创意步骤状态
                this.setCreativeStep(taskId, key, index, 0, 'success', 'LOGO上传完成');
                this.setCreativeStep(taskId, key, index, 1, 'doing', '开始上传素材...');

                // 步骤3：上传素材
                set(key, 3, 'doing', `上传图片素材 ${index + 1}/${this.tpfileList.length}...`);

                let imageUploadSuccess = false;
                let retryCount = 0;
                const maxRetries = 3;

                // 图片上传逻辑（支持重试）
                while (!imageUploadSuccess && retryCount < maxRetries) {
                    try {
                        await this.uploadImgFile4(this.tpfileList[imglist[index]], taskuserlist[key], this.form3.type)
                        imageUploadSuccess = true;
                        this.setCreativeStep(taskId, key, index, 1, 'success', `图片素材 ${index + 1} 上传成功`);
                    } catch (error) {
                        retryCount++;
                        console.error(`图片素材上传失败 (尝试 ${retryCount}/${maxRetries}): ${error.message}`);

                        // 上传失败时删除对应素材
                        this.removeFailedMaterial(imglist[index], 'image');

                        // 重新计算索引数组
                        imglist = this.getBuildIndexes(this.form3.number);
                        console.log(`删除图片后重新计算的索引 (尝试 ${retryCount}):`, imglist);

                        if (retryCount < maxRetries) {
                            this.setCreativeStep(taskId, key, index, 1, 'doing', `图片素材上传失败，正在重试 (${retryCount}/${maxRetries})...`);
                            await this.uploadImgFile4(this.tpfileList[imglist[index]], taskuserlist[key], this.form3.type)
                            this.setCreativeStep(taskId, key, index, 1, 'success', `图片素材 ${index + 1} 上传成功`);
                            // 继续循环，用新的 imglist 重新尝试
                        } else {
                            this.setCreativeStep(taskId, key, index, 1, 'error', `图片素材上传失败: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', '因素材上传失败，跳过创意创建');
                            continue; // 跳过当前创意，继续下一个
                        }
                    }
                }

                // 如果图片上传失败，跳过当前创意
                if (!imageUploadSuccess) {
                    continue;
                }

                set(key, 3, 'success', '素材上传完成');

                let app_logo = sucairesult.data.remote_url
                let data3 = {
                    campaign_id: campaign_id,
                    adgroup_id,
                    creative_name: this.form3.creativeName,
                    type: this.form3.type,
                    app_logo,
                    app_name: this.form3.app_name
                }

                // 根据不同类型处理创意创建
                // [这里包含原有的 GROUP_IMAGE, MOTIVATE_APP, SMALL_IMAGE, BIG_IMAGE, TEXT_LINK, ENGAGEMENT, OPEN_SCREEN, BANNER 等逻辑]
                // 由于代码较长，这里省略具体实现，保持原有逻辑但添加创意步骤状态更新
                if (this.form3.type == 'GROUP_IMAGE' || this.form3.type == 'MOTIVATE_APP') {
                    const cols = 3;
                    let row = [];
                    for (let j = 0; j < cols; j++) {
                        const imgIndex = key * cols + j;
                        row.push(imgIndex);
                    }
                    console.log(row);
                    let image = []
                    for (const key2 in row) {
                        set(key, 3, 'doing', `上传组图素材 ${parseInt(key2) + 1}/${cols}...`);
                        const formData = new FormData();
                        console.log(this.tpfileList[row[key2]]);
                        console.log(this.tpfileList[row[key2]].file.raw);
                        formData.append('file', this.tpfileList[row[key2]].file.raw || this.tpfileList[row[key2]].file);
                        let d = await axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                            },
                            params: {
                                account_id: taskuserlist[key].accountId
                            },
                            signal: signal
                        })
                        image.push(d.data.data.id);
                    }

                    if (this.form3.type == 'MOTIVATE_APP') {
                        data3 = {
                            ...data3,
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            image,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            app_introduction: this.form3.app_introduction[key],
                            app_desc: this.form3.app_desc[key],
                            play_action: this.form3.play_action,
                            play_duration: this.form3.play_duration,
                            click_feedback_url: taskuserlist[key].clickMonitorUrl
                        }
                        data3 = this.removeEmptyFields(data3)

                        // 步骤4：创建创意 - 新增创意步骤状态更新
                        set(key, 4, 'doing', `创建激励应用创意...`);
                        this.setCreativeStep(taskId, key, index, 2, 'doing', '创建激励应用创意中...');

                        await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                            headers: {
                                'Content-Type': 'application/json',
                                'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                            },
                            params: {
                                account_id: taskuserlist[key].accountId
                            },
                            signal: signal
                        }).then(res3 => {
                            if (res3.data.code == 400) {
                                set(key, 4, 'error', `激励应用创意创建失败: ${res3.data.message}`);
                                this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                                this.$message({
                                    showClose: true,
                                    message: res3.data.message
                                });
                                return
                            }
                            if (res3.data.code == 200) {
                                set(key, 4, 'success', `激励应用创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                                this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                                this.$message.success("激励应用创意搭建成功")
                            }
                        }).catch(error => {
                            if (error.name === 'AbortError') throw error;
                            set(key, 4, 'error', `激励应用创意创建异常: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                        });

                    } else if (this.form3.type == 'GROUP_IMAGE') {
                        data3 = {
                            ...data3,
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            image,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            title: this.form3.title[key],
                            second_title: this.form3.second_title[key],
                            click_feedback_url: taskuserlist[key].clickMonitorUrl
                        }
                        data3 = this.removeEmptyFields(data3)

                        // 步骤4：创建创意 - 新增创意步骤状态更新
                        set(key, 4, 'doing', `创建组图创意...`);
                        this.setCreativeStep(taskId, key, index, 2, 'doing', '创建组图创意中...');

                        await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                            headers: {
                                'Content-Type': 'application/json',
                                'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                            },
                            params: {
                                account_id: taskuserlist[key].accountId
                            },
                            signal: signal
                        }).then(res3 => {
                            if (res3.data.code == 400) {
                                set(key, 4, 'error', `组图创意创建失败: ${res3.data.message}`);
                                this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                                this.$message({
                                    showClose: true,
                                    message: res3.data.message
                                });
                                return
                            }
                            if (res3.data.code == 200) {
                                set(key, 4, 'success', `组图创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                                this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                                this.$message.success("组图创意搭建成功")
                            }
                        }).catch(error => {
                            if (error.name === 'AbortError') throw error;
                            set(key, 4, 'error', `组图创意创建异常: ${error.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                        });
                    }

                } else if (this.form3.type == 'SMALL_IMAGE' || this.form3.type == 'BIG_IMAGE') {

                    if (secondTitle && secondTitle.length) {
                        console.log("second_title");
                        console.log(this.form3.title[index]);
                        data3 = {
                            ...data3,
                            image: [this.tpfileListcode[index]],
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            title: this.form3.title[textTitle[index]],
                            second_title: this.form3.second_title[secondTitle[index]],
                            click_feedback_url: taskuserlist[key].clickMonitorUrl
                        }
                    } else {
                        console.log("title");
                        console.log(this.form3.title[index]);
                        data3 = {
                            ...data3,
                            image: [this.tpfileListcode[index]],
                            sub_cate: this.form3.sub_cate,
                            conversion_type: this.form3.conversion_type,
                            download_url: taskuserlist[key].downloadUrl,
                            deep_link: taskuserlist[key].deeplink,
                            target_url_h5: taskuserlist[key].landingPageUrl,
                            title: this.form3.title[textTitle[index]],
                            click_feedback_url: taskuserlist[key].clickMonitorUrl
                        }
                    }
                    data3 = this.removeEmptyFields(data3)

                    // 步骤4：创建创意 - 新增创意步骤状态更新
                    set(key, 4, 'doing', `创建图片创意 ${index + 1}...`);
                    this.setCreativeStep(taskId, key, index, 2, 'doing', '创建图片创意中...');

                    await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    }).then(res3 => {
                        if (res3.data.code == 400) {
                            set(key, 4, 'error', `图片创意创建失败: ${res3.data.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                            this.$message({
                                showClose: true,
                                message: res3.data.message
                            });
                            return
                        }
                        if (res3.data.code == 200) {
                            set(key, 4, 'success', `图片创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.$message.success("图片创意搭建成功")
                        }
                    }).catch(error => {
                        if (error.name === 'AbortError') throw error;
                        set(key, 4, 'error', `图片创意创建异常: ${error.message}`);
                        this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                    });

                } else if (this.form3.type == 'TEXT_LINK') {
                    data3 = {
                        ...data3,
                        image: [this.tpfileListcode[key]],
                        sub_cate: this.form3.sub_cate,
                        conversion_type: this.form3.conversion_type,
                        download_url: taskuserlist[key].downloadUrl,
                        deep_link: taskuserlist[key].deeplink,
                        target_url_h5: taskuserlist[key].landingPageUrl,
                        title: this.form3.title[key],
                        text_link_description: this.form3.text_link_description[key],
                        text_link_btn: this.form3.text_link_btn[key],
                        click_feedback_url: taskuserlist[key].clickMonitorUrl
                    }
                    data3 = this.removeEmptyFields(data3)

                    // 步骤4：创建创意 - 新增创意步骤状态更新
                    set(key, 4, 'doing', `创建文字链创意...`);
                    this.setCreativeStep(taskId, key, index, 2, 'doing', '创建文字链创意中...');

                    await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    }).then(res3 => {
                        if (res3.data.code == 400) {
                            set(key, 4, 'error', `文字链创意创建失败: ${res3.data.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                            this.$message({
                                showClose: true,
                                message: res3.data.message
                            });
                            return
                        }
                        if (res3.data.code == 200) {
                            set(key, 4, 'success', `文字链创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.$message.success("文字链创意搭建成功")
                        }
                    }).catch(error => {
                        if (error.name === 'AbortError') throw error;
                        set(key, 4, 'error', `文字链创意创建异常: ${error.message}`);
                        this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                    });

                } else if (this.form3.type == 'ENGAGEMENT') {
                    data3 = {
                        ...data3,
                        image: [this.tpfileListcode[key]],
                        sub_cate: this.form3.sub_cate,
                        conversion_type: this.form3.conversion_type,
                        download_url: taskuserlist[key].downloadUrl,
                        deep_link: taskuserlist[key].deeplink,
                        target_url_h5: taskuserlist[key].landingPageUrl,
                        title: this.form3.title[key],
                        btn_text: this.form3.btn_text[key],
                        click_feedback_url: taskuserlist[key].clickMonitorUrl
                    }
                    data3 = this.removeEmptyFields(data3)

                    // 步骤4：创建创意 - 新增创意步骤状态更新
                    set(key, 4, 'doing', `创建互动创意...`);
                    this.setCreativeStep(taskId, key, index, 2, 'doing', '创建互动创意中...');

                    await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    }).then(res3 => {
                        if (res3.data.code == 400) {
                            set(key, 4, 'error', `互动创意创建失败: ${res3.data.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                            this.$message({
                                showClose: true,
                                message: res3.data.message
                            });
                            return
                        }
                        if (res3.data.code == 200) {
                            set(key, 4, 'success', `互动创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.$message.success("互动创意搭建成功")
                        }
                    }).catch(error => {
                        if (error.name === 'AbortError') throw error;
                        set(key, 4, 'error', `互动创意创建异常: ${error.message}`);
                        this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                    });

                } else if (this.form3.type == 'OPEN_SCREEN' || this.form3.type == 'BANNER') {
                    console.log(this.tpfileListcode[key]);
                    console.log(this.tpfileListcode);
                    data3 = {
                        ...data3,
                        image: [this.tpfileListcode[index]],
                        sub_cate: this.form3.sub_cate,
                        conversion_type: this.form3.conversion_type,
                        download_url: taskuserlist[key].downloadUrl,
                        deep_link: taskuserlist[key].deeplink,
                        target_url_h5: taskuserlist[key].landingPageUrl,
                        click_feedback_url: taskuserlist[key].clickMonitorUrl
                    }
                    data3 = this.removeEmptyFields(data3)

                    // 步骤4：创建创意 - 新增创意步骤状态更新
                    set(key, 4, 'doing', `创建${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意 ${index + 1}...`);
                    this.setCreativeStep(taskId, key, index, 2, 'doing', `创建${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意中...`);

                    await axios.post('/qttupapi/openapi/v1/creative/create', data3, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    }).then(res3 => {
                        if (res3.data.code == 400) {
                            set(key, 4, 'error', `${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意创建失败: ${res3.data.message}`);
                            this.setCreativeStep(taskId, key, index, 2, 'error', `创建失败: ${res3.data.message}`);
                            this.$message({
                                showClose: true,
                                message: res3.data.message
                            });
                            return
                        }
                        if (res3.data.code == 200) {
                            set(key, 4, 'success', `${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意创建成功，创意ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.setCreativeStep(taskId, key, index, 2, 'success', `创意创建成功，ID: ${res3.data.data.creative_id || '未知ID'}`);
                            this.$message.success(`${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意搭建成功`)
                        }
                    }).catch(error => {
                        if (error.name === 'AbortError') throw error;
                        set(key, 4, 'error', `${this.form3.type === 'OPEN_SCREEN' ? '开屏' : 'Banner'}创意创建异常: ${error.message}`);
                        this.setCreativeStep(taskId, key, index, 2, 'error', `创建异常: ${error.message}`);
                    });
                }

                this.setCreativeStep(taskId, key, index, 2, 'success', '创意搭建成功');
            }
        },
        initCreativeLogs(taskId, userIndex, creativeCount) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) {
                console.error('任务或用户详情未找到:', taskId);
                return;
            }

            const user = task.userDetails[userIndex];
            if (!user) {
                console.error('用户未找到:', userIndex);
                return;
            }

            // 确保 creativeCount 是有效数字
            creativeCount = parseInt(creativeCount) || 0;
            if (creativeCount <= 0) {
                console.error('创意数量无效:', creativeCount);
                return;
            }

            console.log(`初始化创意日志: 任务${taskId}, 用户${userIndex}, 创意数量${creativeCount}`);

            // 使用 Vue.set 确保响应式更新
            this.$set(user, 'creatives', []);

            // 清空现有创意，重新初始化
            user.creatives = [];

            // 创建指定数量的创意
            for (let i = 0; i < creativeCount; i++) {
                user.creatives.push({
                    id: i + 1, // 简单的数字ID
                    status: 'waiting',
                    steps: [
                        { name: '上传LOGO', status: 'wait', detail: null },
                        { name: '素材上传', status: 'wait', detail: null },
                        { name: '创意搭建', status: 'wait', detail: null }
                    ],
                    materials: {
                        video: null,
                        cover: null,
                        image: null
                    }
                });
            }

            console.log(`✅ 成功初始化 ${user.creatives.length} 条创意:`, user.creatives.map(c => c.id));
        },

        // 新增：设置创意步骤状态
        setCreativeStep(taskId, userIndex, creativeIndex, stepIndex, status, detail = null) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            const user = task.userDetails[userIndex];
            if (!user || !user.creatives) return;

            const creative = user.creatives[creativeIndex];
            if (!creative || !creative.steps) return;

            const step = creative.steps[stepIndex];
            if (!step) return;

            step.status = status;
            step.detail = this.formatDetail(detail);

            // 更新创意状态
            if (status === 'doing') creative.status = 'running';
            if (status === 'error') creative.status = 'failed';
            if (status === 'success' && creative.steps.every(s => s.status === 'success')) {
                creative.status = 'done';
            }
        },

        // 新增：删除失败素材的方法
        removeFailedMaterial(index, type) {
            if (type === 'video') {
                // 删除视频素材和对应的封面
                if (this.videofileList && this.videofileList.length > index) {
                    this.videofileList.splice(index, 1);
                }
                // 同时删除对应的封面
                if (this.videotpfileList && this.videotpfileList.length > index) {
                    this.videotpfileList.splice(index, 1);
                }
            } else if (type === 'cover') {
                // 只删除封面
                if (this.videotpfileList && this.videotpfileList.length > index) {
                    this.videotpfileList.splice(index, 1);
                }

            } else if (type === 'image') {
                // 删除图片素材
                if (this.tpfileList && this.tpfileList.length > index) {
                    this.tpfileList.splice(index, 1);
                }

            }

            console.log(`已删除${type}类型素材，索引: ${index}`);
        },

        // 新增：停止任务方法
        stopTask(taskId) {
            const controller = this.taskControllers.get(taskId);
            if (controller) {
                controller.abort();
                this.isTaskStopped.set(taskId, true);

                const task = this.tasks.find(t => t.id === taskId);
                if (task) {
                    task.status = 'stopped';
                    // 更新所有进行中的用户状态
                    task.userDetails.forEach(user => {
                        if (user.status === 'running') {
                            user.status = 'stopped';
                            user.steps.forEach(step => {
                                if (step.status === 'doing') {
                                    step.status = 'error';
                                    step.detail = '任务被停止';
                                }
                            });
                            // 更新创意状态
                            if (user.creatives) {
                                user.creatives.forEach(creative => {
                                    if (creative.status === 'running') {
                                        creative.status = 'stopped';
                                        creative.steps.forEach(step => {
                                            if (step.status === 'doing') {
                                                step.status = 'error';
                                                step.detail = '任务被停止';
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    });
                }

                this.$message.warning(`任务 #${taskId} 已停止`);
            } else {
                this.$message.warning('任务未找到或已结束');
            }
        },

        // 新增：删除任务方法
        deleteTask(taskId) {
            const task = this.tasks.find(t => t.id === taskId);
            if (task && (task.status === 'stopped' || task.status === 'failed' || task.status === 'done' || task.status === 'error')) {
                // 停止任务如果还在运行
                this.stopTask(taskId);

                // 从任务列表中移除
                this.tasks = this.tasks.filter(t => t.id !== taskId);
                this.taskControllers.delete(taskId);
                this.isTaskStopped.delete(taskId);

                this.$message.success('任务已删除');
            } else if (task && task.status === 'running') {
                this.$message.warning('请先停止运行中的任务再删除');
            } else {
                this.$message.warning('任务未找到');
            }
        },
        PlacementTimehange(time) {
            if (time && time.length === 2) {
                const formatted = time.map(date => dayjs(date).format('YYYY-MM-DD'));
                this.startDate = formatted[0]
                this.endDate = formatted[1]
            } else {
                console.log('未选择日期');
            }
        },
        ddddccc(e) {
            console.log(e);
            console.log(this.form2.dingxiangbao);
            let a = JSON.parse(this.form2.dingxiangbao)
            console.log(a);
        },
        async createdanyuan(taskId) {
            // 创建任务控制器
            const controller = new AbortController();
            const signal = controller.signal;
            this.taskControllers.set(taskId, controller);
            this.isTaskStopped.set(taskId, false);

            const task = this.tasks.find(t => t.id === taskId);
            if (!task) {
                console.error('任务未找到:', taskId);
                return;
            }

            const set = (userIndex, stepIndex, status, detail) =>
                this.setStep(taskId, userIndex, stepIndex, status, detail);

            try {
                console.log(this.ids_list);
                this.tpfileListcode = []
                this.uploadPercent = 0
                this.showProgress = true

                let taskuserlist = this.ids_list
                console.log(taskuserlist);
                set(null, 0, 'doing', `开始处理 ${taskuserlist.length} 个广告项`);

                for (let key = 0; key < taskuserlist.length; key++) {
                    // 检查任务是否被停止
                    if (this.isTaskStopped.get(taskId)) {
                        set(null, 0, 'error', '任务已被手动停止');
                        set(key, 0, 'error', '任务停止');
                        break;
                    }

                    // 检查请求是否被中止
                    if (signal.aborted) {
                        set(null, 0, 'error', '任务已被中止');
                        break;
                    }

                    task.currentIndex = key + 1;
                    set(null, 0, 'doing', `正在搭建第 ${key + 1}/${taskuserlist.length} 条指令: ${taskuserlist[key].accountName}`);
                    this.uploadPercent = Math.round((key / taskuserlist.length) * 100)
                    this.$message.success(`正在搭建第${key + 1}条指令`)
                    console.log(`第${key}项：`);

                    // 步骤1：创建广告计划
                    set(key, 0, 'doing', '创建广告计划中...');
                    let data = {
                        campaign_name: taskuserlist[key].campaignName,
                        optimization_goal: this.form.optimization_goal,
                        app_marketing_type: this.form.app_marketing_type,
                        start_date: this.startDate,
                        end_date: this.endDate,
                        budget: this.form.budget * 100
                    }

                    let campaignRes = await axios.post('/qttupapi/openapi/v1/campaign/create', data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    });

                    if (campaignRes.data.code == 400) {
                        set(key, 0, 'error', `创建失败: ${campaignRes.data.message}`);
                        this.$message({
                            showClose: true,
                            message: campaignRes.data.message
                        });
                        continue;
                    }

                    set(key, 0, 'success', `创建成功: ${campaignRes.data.data.campaign_id || '未知ID'}`);

                    // 步骤2：创建广告单元
                    set(key, 1, 'doing', '创建广告单元中...');
                    let a = JSON.parse(this.form2.dingxiangbao)
                    let gender = a.gender;
                    let selectedAges = a.selectedAges;
                    let osType = a.osType;
                    let selectedPhonePrices = a.selectedPhonePrices;
                    let selectedNetworks = a.selectedNetworks;
                    let app_package_value_arr = a.app_package_value_arr;
                    let app_filter_value_arr = a.app_filter_value_arr;
                    if (app_filter_value_arr.length > 0) {
                        this.form.appFilter = "ENABLE"
                    }
                    if (app_package_value_arr.length > 0) {
                        this.form.appPackage = "ENABLE"
                    }
                    let timeType = a.timeType;
                    let regionType = a.regionType;

                    if (typeof a.regionType === 'string') {
                        regionType = a.regionType.split(',').map(Number);
                    } else if (Array.isArray(a.regionType)) {
                        regionType = a.regionType.map(Number);
                    }

                    let conversion_form = {};
                    if (a.conversion_filter_orient_status == 'ENABLE') {
                        if (a.conversion_filter_orient == "COMMON") {
                            // conversion_form = { conversion_filter_orient: a.conversion_filter_orient }
                        } else {
                            if (a.conversion_filter_orient == 'ACCOUNT' || a.conversion_filter_orient == 'COMPANY' || a.conversion_filter_orient == 'PRODUCT' || a.conversion_filter_orient == 'PACKAGE') {
                                conversion_form = {
                                    conversion_filter_orient: a.conversion_filter_orient,
                                    conversion_filter_orient_duration: a.conversion_filter_orient_duration,
                                    conversion_goal_filter: a.conversion_goal_filter
                                }
                                if (a.conversion_filter_orient == 'PACKAGE') {
                                    let arr = a.pack_name_value.split(";");
                                    conversion_form = { ...conversion_form, pack_name_value: arr }
                                }
                            } else {
                                conversion_form = {
                                    conversion_filter_orient: a.conversion_filter_orient,
                                    conversion_goal_filter: a.form.conversion_goal_filter
                                }
                            }
                        }
                    }

                    let data2 = {
                        campaign_id: campaignRes.data.data.campaign_id,
                        adgroup_name: this.form2.adgroup_name,
                        adslot_type_group: this.form2.selectedAdSlots,
                        adslot_type: this.adSlotType,
                        media_type: this.form2.mediaType,
                        media_group: this.form2.selectedMedia,
                        audience_orient: this.form2.audience_orient,
                        audience_orient_filter: this.form2.audience_orient_filter,
                        os_type: osType,
                        regions: regionType,
                        hours: timeType,
                        gender: gender,
                        age: selectedAges,
                        mobile: selectedPhonePrices,
                        network_type: selectedNetworks,
                        app_package: this.form.appPackage,
                        app_package_value: app_package_value_arr,
                        app_filter: this.form.appFilter,
                        app_filter_value: app_filter_value_arr,
                        frequency: parseInt(this.form2.showFrequency),
                        click_frequency: parseInt(this.form2.clickFrequency),
                        charge_type: this.form2.chargeType,
                        bid: Math.round(Number(this.form2.bidPrice) * 100),
                    }


                    if (this.form2.chargeType == 'OCPM') {
                        data2 = {
                            ...data2,
                            cpa_bid: Math.round(Number(this.form2.cpaBid) * 100),
                            conversion_goal: this.form2.conversionGoal,
                            conversion_from: this.form2.conversionFrom
                        }
                    }

                    if (this.form2.deepConversionGoal != 'NO' && (this.form2.deepConversionGoal == 'RETENTION' || this.form2.deepConversionGoal == 'TWO_RETENTION' || this.form2.deepConversionGoal == 'SIX_RETENTION')) {
                        data2 = {
                            ...data2,
                            is_deep_ocpx: 'ENABLE',
                            deep_conversion_goal: this.form2.deepConversionGoal,
                            retention_rate: this.form2.retentionRate
                        }
                    } else if (this.form2.deepConversionGoal != 'NO' && (this.form2.deepConversionGoal == 'CHARGE' || this.form2.deepConversionGoal == 'KEY_ACTION')) {
                        data2 = {
                            ...data2,
                            is_deep_ocpx: 'ENABLE',
                            deep_conversion_goal: this.form2.deepConversionGoal,
                            deep_cpa_bid: Math.round(Number(this.form2.deepCpaBid) * 100),
                        }
                    }

                    if (this.form2.chargeType == 'OCPM') {
                        data2 = { ...data2, ...conversion_form, transfer_optimize: this.form2.transfer_optimize }
                    }
                    data2 = { ...data2, ocpx_expand: this.form2.ocpx_expand }

                    Object.keys(data2).forEach(key => {
                        if (data2[key] === undefined || data2[key] === null || data2[key] === '') {
                            delete data2[key];
                        }
                        if (Array.isArray(data2[key]) && data2[key].length === 0) {
                            delete data2[key];
                        }
                    });

                    let adgroupRes = await axios.post('/qttupapi/openapi/v1/adgroup/create_v2', data2, {
                        headers: {
                            'Content-Type': 'application/json',
                            'OGW_ACCESS_TOKEN': taskuserlist[key].utoken
                        },
                        params: {
                            account_id: taskuserlist[key].accountId
                        },
                        signal: signal
                    });

                    if (adgroupRes.data.code == 400) {
                        set(key, 1, 'error', `创建失败: ${adgroupRes.data.message}`);
                        this.$message({
                            showClose: true,
                            message: adgroupRes.data.message
                        });
                        continue;
                    }

                    set(key, 1, 'success', `创建成功: ${adgroupRes.data.data.adgroup_id || '未知ID'}`);

                    let adgroup_id = adgroupRes.data.data.adgroup_id

                    // 步骤3-4：创建创意
                    await this.cydj(key, campaignRes.data.data.campaign_id, adgroup_id, taskuserlist, taskId, signal)
                    this.uploadPercent = Math.round(((key + 1) / taskuserlist.length) * 100)
                }

                if (!this.isTaskStopped.get(taskId)) {
                    this.uploadPercent = 100
                    setTimeout(() => {
                        this.showProgress = false
                    }, 31500)
                    set(null, 1, 'success', '所有任务完成');
                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    set(null, 0, 'error', '任务已被中止');
                } else {
                    set(null, 0, 'error', `任务执行异常: ${error.message}`);
                    console.error('createdanyuan error:', error);
                }
            } finally {
                // 清理任务控制器
                this.taskControllers.delete(taskId);
                this.isTaskStopped.delete(taskId);
            }
        },

        removeEmptyFields(obj) {
            Object.keys(obj).forEach(key => {
                if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
                if (Array.isArray(obj[key]) && obj[key].length === 0) {
                    delete obj[key];
                }
            });
            return obj;
        },
        async handlelistByUbs() {
            // this.ids_list = []
            // let arr = this.btgjc.split('\n').filter(line => line.trim());
            await axios.get('https://control.zjwec.cn/api/qttad/directives/all', {
                params: { userId: this.userId },
            }).then(res => {
                console.log(res);
                this.records = res.data
            });

        },
        async recordsChange(e) {
            console.log(e);
            if (!e) return
            let arr = await axios.get('https://control.zjwec.cn/api/qttad/accounts', {
                params: { directiveId: e, userId: this.userId },
            })
            console.log(arr);
            const filteredData = arr.data.filter(item => item.status !== false);
            console.log(filteredData);


            await axios.get('https://control.zjwec.cn/api/qtttoken/list').then(res2 => {
                console.log(res2);
                console.log(res2.data);


                this.ids_list = filteredData.map(customer => {
                    // 首先尝试用 khname 匹配
                    let matchedUser = res2.data.find(user => user.uname === customer.controlAccountId);



                    // 如果找到匹配用户，则添加 utoken
                    if (matchedUser) {
                        return {
                            ...customer,
                            utoken: matchedUser.utoken
                        };
                    }

                    // 没有匹配则保持原样
                    return customer;
                });
                console.log(this.ids_list);
                this.getdmplist()
                // console.log(this.ids_list);

            })



            // Promise.all(
            //     arr.data.map(item => {
            //         return axios.get('https://control.zjwec.cn/api/qttpd/listByUbs', {
            //             params: { ubs: item },
            //         });
            //     })
            // ).then(responses => {
            //     console.log('所有请求完成:', responses);
            //     let arr2 = []
            //     // 处理所有返回结果
            //     responses.forEach((res, index) => {
            //         console.log(`第${index + 1}个结果:`, res.data);
            //         arr2 = [...arr2, ...res.data]
            //     });
            //     console.log(arr2);
            //     axios.get('https://control.zjwec.cn/api/qtttoken/list').then(res2 => {
            //         console.log(res2.data);


            //         this.ids_list = arr2.map(customer => {
            //             // 首先尝试用 khname 匹配
            //             let matchedUser = res2.data.find(user => user.uname === customer.khname);



            //             // 如果找到匹配用户，则添加 utoken
            //             if (matchedUser) {
            //                 return {
            //                     ...customer,
            //                     utoken: matchedUser.utoken
            //                 };
            //             }

            //             // 没有匹配则保持原样
            //             return customer;
            //         });
            //         this.getdmplist()
            //         // console.log(this.ids_list);

            //     })


            // }).catch(error => {
            //     console.error('请求出错:', error);
            // });

        },
        // handlelistByUbs() {
        //     this.ids_list = []
        //     let arr = this.btgjc.split('\n').filter(line => line.trim());
        //     Promise.all(
        //         arr.map(item => {
        //             return axios.get('https://control.zjwec.cn/api/qttpd/listByUbs', {
        //                 params: { ubs: item },
        //             });
        //         })
        //     ).then(responses => {
        //         console.log('所有请求完成:', responses);
        //         let arr2 = []
        //         // 处理所有返回结果
        //         responses.forEach((res, index) => {
        //             console.log(`第${index + 1}个结果:`, res.data);
        //             arr2 = [...arr2, ...res.data]
        //         });
        //         console.log(arr2);
        //         axios.get('https://control.zjwec.cn/api/qtttoken/list').then(res2 => {
        //             console.log(res2.data);


        //             this.ids_list = arr2.map(customer => {
        //                 // 首先尝试用 khname 匹配
        //                 let matchedUser = res2.data.find(user => user.uname === customer.khname);



        //                 // 如果找到匹配用户，则添加 utoken
        //                 if (matchedUser) {
        //                     return {
        //                         ...customer,
        //                         utoken: matchedUser.utoken
        //                     };
        //                 }

        //                 // 没有匹配则保持原样
        //                 return customer;
        //             });
        //             this.getdmplist()
        //             // console.log(this.ids_list);

        //         })


        //     }).catch(error => {
        //         console.error('请求出错:', error);
        //     });
        //     console.log(this.ids_list);
        // },
        handleChange(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient = value
        },
        handleChange2(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient_filter = value
        },
        getdmplist() {
            console.log(this.ids_list);
            axios.get('/qttupapi/openapi/v1/conv/dmp/list', {
                params: {
                    account_id: this.ids_list[0].accountId
                },
                headers: {
                    'Content-Type': 'application/json',
                    'OGW_ACCESS_TOKEN': this.ids_list[0].utoken
                }
            })
                .then(res => {
                    console.log('请求成功:', res.data);
                    if (res.data.code == 40000) {
                        this.$message.warning("密钥过期，重新录入密钥后重试")
                        return
                    }
                    this.audience_list = res.data.data.filter(item => item.category_name == "dmp推荐人群")[0]
                    this.options = [{
                        value: this.audience_list.category_id,
                        label: this.audience_list.category_name,
                        children: this.audience_list.audience_list.map(item => ({
                            value: item.audience_id,
                            label: item.audience_name,
                            rawData: item // 保留原始数据
                        }))
                    }]
                    console.log(this.audience_list);
                })
                .catch(error => {
                    console.error('请求失败:', error);
                    if (error.response) {
                        console.log('错误状态码:', error.response.status);
                        console.log('错误响应数据:', error.response.data);
                    }
                });
        },

        handleInput2() {
            this.form3.second_title = this.titlesString2
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.second_title);

            // 检查每一行是否在字数限制（8-23）内
            // this.linesWithLimitError = this.form3.title
            //     .map((line, index) => ({
            //         line: line,
            //         index: index + 1,
            //         length: line.length,
            //     }))
            //     .filter(item => item.length < 8 || item.length > 23) // 不在范围内的行
            //     .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },
        handleInput() {
            this.form3.title = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.title);

            // 检查每一行是否在字数限制（8-23）内
            this.linesWithLimitError = this.form3.title
                .map((line, index) => ({
                    line: line,
                    index: index + 1,
                    length: line.length,
                }))
                .filter(item => item.length < 8 || item.length > 23) // 不在范围内的行
                .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },
        handleInput4() {
            this.form3.app_introduction = this.titlesString11
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleInput5() {
            this.form3.app_desc = this.titlesString4
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleInput6() {
            this.form3.description = this.titlesString5
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleInput7() {
            this.form3.text_link_description = this.titlesString6
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleInput8() {
            this.form3.text_link_btn = this.titlesString7
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleInput9() {
            this.form3.text_link_btn = this.titlesString8
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
        },
        handleRemove2(file) {
            this.videofileListcode = []
            const tp = this.videofileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videofileList.splice(tp, 1);
            }
        },
        videohandleFileChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.status !== 'ready') return;
            this.videofileList = [...this.videofileList,
            {
                ...file,
                url: file.url || URL.createObjectURL(file.raw),
                file
            }
            ]
            console.log(this.videofileList);

            if (this.autoGenerateCover) {
                this.extractFrameForNewVideo(file);
            }
        },
        async extractFrameForNewVideo(file) {
            try {
                if (file.status !== 'ready') return;

                console.log('开始为新增视频抽帧:', file.name);

                // 找到文件在列表中的索引
                const fileIndex = this.videofileList.findIndex(item => item.uid === file.uid);
                if (fileIndex === -1) {
                    console.warn('未找到文件在列表中的位置');
                    return;
                }

                const frameResult = await this.extractFrameFromVideoFile(file, fileIndex);

                if (frameResult) {
                    this.addFrameToCoverList(frameResult, fileIndex);

                    this.$message({
                        message: `视频 "${file.name}" 抽帧成功`,
                        type: 'success',
                        duration: 2000
                    });
                }

            } catch (error) {
                console.warn(`视频 "${file.name}" 抽帧失败:`, error);

                this.$message({
                    message: `视频 "${file.name}" 抽帧失败: ${error.message}`,
                    type: 'warning',
                    duration: 3000
                });
            }
        },


        async extractFrameFromVideoFile(videoItem, index) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // 获取视频文件
                const videoFile = videoItem.raw;

                if (!videoFile || !videoFile.type.startsWith('video/')) {
                    reject(new Error('不是有效的视频文件'));
                    return;
                }

                const videoURL = URL.createObjectURL(videoFile);
                video.src = videoURL;
                video.muted = true;
                video.playsInline = true;
                video.crossOrigin = 'anonymous';

                video.addEventListener('loadeddata', () => {
                    canvas.width = video.videoWidth || 640;
                    canvas.height = video.videoHeight || 360;
                    video.currentTime = 0.1;
                });

                video.addEventListener('seeked', () => {
                    try {
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob((blob) => {
                            if (!blob) {
                                reject(new Error('Canvas转换失败'));
                                return;
                            }

                            const frameFile = new File([blob], `封面_${videoFile.name.replace(/\.[^/.]+$/, "")}.jpg`, {
                                type: 'image/jpeg',
                                lastModified: Date.now()
                            });

                            URL.revokeObjectURL(videoURL);

                            resolve({
                                frameFile: frameFile,
                                videoIndex: index,
                                videoName: videoFile.name
                            });

                        }, 'image/jpeg', 0.85);

                    } catch (error) {
                        URL.revokeObjectURL(videoURL);
                        reject(error);
                    }
                });

                video.addEventListener('error', (e) => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error(`视频加载失败: ${e.message}`));
                });

                setTimeout(() => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error('视频帧提取超时'));
                }, 15000);
            });
        },


        addFrameToCoverList(frameResult, videoIndex) {
            const { frameFile, videoName } = frameResult;

            const coverFileItem = {
                uid: `frame_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                name: `封面_${videoName.replace(/\.[^/.]+$/, "")}.jpg`,
                size: frameFile.size,
                type: frameFile.type,
                raw: frameFile,
                url: URL.createObjectURL(frameFile),
                status: 'success',
                isFrame: true,
                sourceVideoIndex: videoIndex,
                sourceVideoName: videoName
            };

            // 确保封面列表存在
            if (!this.videotpfileList) {
                this.videotpfileList = [];
            }

            this.insertCoverInOrder(coverFileItem, videoIndex);

            console.log(`新增封面:`, coverFileItem);
            console.log(`当前封面列表顺序:`, this.videotpfileList.map(item => item.sourceVideoIndex));

            // 触发响应式更新
            this.$forceUpdate();

            this.$message({
                message: `已为 "${videoName}" 生成封面`,
                type: 'success',
                duration: 1500
            });
        },


        insertCoverInOrder(coverFileItem, videoIndex) {
            // 如果列表为空，直接添加
            if (this.videotpfileList.length === 0) {
                this.videotpfileList.push(coverFileItem);
                return;
            }

            // 查找插入位置
            let insertIndex = this.videotpfileList.length;

            for (let i = 0; i < this.videotpfileList.length; i++) {
                const currentCover = this.videotpfileList[i];

                // 如果找到相同视频索引的封面，替换它
                if (currentCover.sourceVideoIndex === videoIndex) {
                    this.videotpfileList.splice(i, 1, coverFileItem);
                    return;
                }

                // 找到第一个比当前视频索引大的位置，插入到它前面
                if (currentCover.sourceVideoIndex > videoIndex) {
                    insertIndex = i;
                    break;
                }
            }

            // 插入到正确位置
            this.videotpfileList.splice(insertIndex, 0, coverFileItem);
        },
        txReset() {
            this.txList = []
        },
        txhandleConfirmUpload() { },
        txhandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;
            this.tpfileList = [...this.tpfileList, {
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        videotphandleFileChange(file, fileList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;

            // 如果有正在替换的文件
            if (this.replacingIndex !== undefined && this.replacingIndex !== null) {
                // 替换指定位置的文件
                this.videotpfileList.splice(this.replacingIndex, 1, {
                    name: file.name,
                    url: file.url,
                    uid: file.uid || new Date().getTime(),
                    status: 'success',
                    file: file
                });

                console.log(`替换了第${this.replacingIndex + 1}个文件`);

                // 重置替换索引
                this.replacingIndex = null;

            } else {
                // 正常的添加文件逻辑（保持您原有的代码不变）
                this.videotpfileList = [...this.videotpfileList, {
                    name: file.name,
                    url: file.url,
                    uid: file.uid || new Date().getTime(), // 必须有 uid
                    status: 'success',
                    file: file
                }];
            }
        },
        tphandleRemove(file) {
            this.tpfileListcode = []
            const tp = this.tpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.tpfileList.splice(tp, 1);
            }
            console.log(this.tpfileList);
            console.log(this.tpfileListcode);
        },
        tphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        txhandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;

            console.log('准备上传文件:', file);
            this.txfileList = []
            this.txfileList = [{
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        uploadImgFile(img, LOGO, item) {
            console.log(item);
            const formData = new FormData();
            formData.append('file', img.raw || img); // 确保传递的是原始文件对象
            formData.append('LOGO', LOGO || ''); // 确保LOGO不为undefined

            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // 浏览器会自动设置正确的boundary
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res);
                if (res.data.code != 200) {
                    this.$message.error("上传失败:", res.data.message)
                }
                // 返回完整的响应数据
                return res.data;
            }).catch(error => {
                // 统一处理错误
                console.error('文件上传失败:', error);
                if (error.response) {
                    // 服务器返回的错误
                    throw new Error(error.response.data.message || '上传失败');
                } else {
                    // 网络或其他错误
                    throw new Error(error.message || '网络错误');
                }
            });
        },
        async uploadImgFile2(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();

            formData.append('file', img.file.raw || img.file);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data);
                if (res.data.code != 200) {
                    this.$message.error("上传失败:", res.data.message)
                }
                const id = res.data.data.screen ? res.data.data.screen.id : res.data.data.id;

                this.tpfileListcode = [...this.tpfileListcode, id];


                console.log("--------------------------------------------------------");
                // console.log(res.data.data.screen.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        async uploadImgFile4(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            // formData.append('file', img.file.raw || img.file);
            if (img.raw) {
                formData.append('file', img.raw);
                console.log('使用img.raw');
            } else if (img.file) {
                // 如果确实有file属性（虽然你的数据结构显示没有）
                formData.append('file', img.file.raw || img.file);
                console.log('使用img.file.raw');
            } else {
                // 如果都没有，尝试直接使用img本身
                formData.append('file', img);
                console.log('直接使用img对象');
            }
            if (material_type == "MOTIVATE_VIDEO_VERTICAL" || material_type == "MOTIVATE_VIDEO_HORIZONTAL	") {
                let i = material_type == 'MOTIVATE_VIDEO_VERTICAL' ? 'VERTICAL_COVER' : 'HORIZONTAL_COVER'
                formData.append('material_type', i);
            }
            // formData.append('material_type', 'VERTICAL_COVER');

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId,

                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success("上传成功:", res.data.message)
                }
                if (res.data.code != 200) {
                    this.$message.error("上传失败:", res.data.message)
                }
                console.log(res.data.data.id);
                this.tpfileListcode = [...this.tpfileListcode, res.data.data.id];
                console.log(this.tpfileListcode);
                console.log("--------------------------------------------------------");
                console.log(res.data.data.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        async uploadImgFile5(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            // formData.append('file', img.file.raw || img.file);
            if (img.raw) {
                formData.append('file', img.raw);
                console.log('使用img.raw');
            } else if (img.file) {
                // 如果确实有file属性（虽然你的数据结构显示没有）
                formData.append('file', img.file.raw || img.file);
                console.log('使用img.file.raw');
            } else {
                // 如果都没有，尝试直接使用img本身
                formData.append('file', img);
                console.log('直接使用img对象');
            }
            // if (material_type == "MOTIVATE_VIDEO_VERTICAL" || material_type == "MOTIVATE_VIDEO_HORIZONTAL	") {
            //     let i = material_type == 'MOTIVATE_VIDEO_VERTICAL' ? 'VERTICAL_COVER' : 'HORIZONTAL_COVER'
            //     formData.append('material_type', i);
            // }
            switch (material_type) {
                case "MOTIVATE_VIDEO_VERTICAL":
                    formData.append('material_type', 'VERTICAL_COVER');
                    break;
                case "MOTIVATE_VIDEO_HORIZONTAL":
                    formData.append('material_type', 'HORIZONTAL_COVER');
                    break;
                case "VIDEO_VERTICAL":
                    // 处理竖版视频广告
                    formData.append('material_type', 'VERTICAL_COVER');
                    break;
                case "VIDEO_HORIZONTAL":
                    // 处理横版视频广告
                    formData.append('material_type', 'HORIZONTAL_COVER');
                    break;
                default:
                    // 默认处理
                    formData.append('material_type', material_type);
                    break;
            }
            // formData.append('material_type', 'VERTICAL_COVER');

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId,

                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success("上传成功:", res.data.message)
                }
                if (res.data.code != 200) {
                    this.$message.error("上传失败:", res.data.message)
                }
                console.log(res.data.data.id);
                this.videotpfileListcode = [...this.videotpfileListcode, res.data.data.id];
                console.log(this.tpfileListcode);
                console.log("--------------------------------------------------------");
                console.log(res.data.data.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        clearAllcoverImages() {
            this.videotpfileList = [];
            this.videotpfileListcode = []
            this.$message.success('已清空封面图片');
        },
        async uploadImgFile3(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file); // 确保传递的是原始文件对象
            formData.append('material_type', material_type);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(async res => {
                if (res.data.code == 200) {
                    this.$message.success("上传成功:", res.data.message)
                }
                if (res.data.code != 200) {
                    this.$message.error("上传失败:", res.data.message)
                }
                console.log(res.data.data.post_url);
                console.log(res.data.data.id);
                this.videofileListcode = [...this.videofileListcode, res.data.data.id]
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },



        handleAutoCoverChange(e) {
            console.log(e);
            this.autoGenerateCover = e
        },
        onChange(a, fileList) {
            console.log("11111");
            this.txuploadDialogVisible = true
        },
        handlePictureCardPreview: function (file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 处理删除
        handleRemove(file) {
            const tp = this.txfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.txfileList.splice(tp, 1);
            }
            console.log(this.txfileList);
        },
        handleMaterialsdialog() {
            this.creativeMaterials = true
        },
        querySearch(queryString, cb) {
            // 过滤出匹配的建议项
            //   const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase()): this.allRestaurants;
            const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase())) : this.allRestaurants;
            // 调用回调函数返回建议列表
            cb(results)
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        CreativeTypechang() {
            console.log(this.selectedStyle);
            this.form3.type = this.selectedStyle
            this.createTypedialog = false
        },
        selectStyle(style) {
            this.selectedStyle = style.value
            console.log(style.value);
            let materialType;

            switch (style.value) {
                case 'SMALL_IMAGE':
                    materialType = 'IMAGE';
                    break;
                case 'BIG_IMAGE':
                    materialType = 'BIG_IMAGE';
                    break;

                case 'GROUP_IMAGE':
                    materialType = 'IMAGE';
                    break;

                case 'VIDEO_HORIZONTAL':
                    materialType = 'HORIZONTAL_VIDEO';
                    break;

                case 'VIDEO_VERTICAL':
                    materialType = 'VERTICAL_VIDEO';

                    break;

                case 'TEXT_LINK':
                    materialType = 'TEXT';
                    break;

                case 'ENGAGEMENT':
                    materialType = 'INTERACTIVE';
                    break;

                case 'OPEN_SCREEN':
                    materialType = 'SCREEN';

                    break;

                case 'BANNER':
                    materialType = 'BANNER';

                    break;

                case 'MOTIVATE_APP':
                    materialType = 'MOTIVATE_APP';
                    break;

                case 'MOTIVATE_VIDEO_HORIZONTAL':
                    materialType = 'HORIZONTAL_VIDEO';
                    break;

                case 'MOTIVATE_VIDEO_VERTICAL':
                    materialType = 'VERTICAL_VIDEO';
                    break;

                default:
                    throw new Error(`未知的广告类型: ${styleValue}`);
            }
            console.log(materialType);
            this.material_type = materialType
            this.selectedStylelabel = style.label
        },
        handleStyleChange(value) {
            this.$emit('change', value);
        },

        // 打开样式选择对话框（示例）
        openStyleDialog() {
            this.createTypedialog = true
        },
        handleinterestChange() {

        },
        handleTimeTypeChange(val) {
            if (val === 'COMMON') {
                this.resetSelection()
            }
        },

        // 处理时段范围变化
        handleTimeRangeChange(val) {
            switch (val) {
                case '1': // 全部时间
                    this.form2.selectedDays = Array(7).fill(true)
                    break
                case '2': // 工作日
                    this.form2.selectedDays = [true, true, true, true, true, false, false]
                    break
                case '3': // 周末
                    this.form2.selectedDays = [false, false, false, false, false, true, true]
                    break
            }
            this.updateHoursSelection()
        },

        // 处理日期选择变化
        handleDayChange(dayIndex, isSelected) {
            if (isSelected) {
                // 选中日期时，默认选中该日期所有时间段
                this.$set(this.form2.selectedHours, dayIndex, Array(24).fill(true))
            } else {
                // 取消选中日期时，清空该日期所有时间段
                this.$set(this.form2.selectedHours, dayIndex, Array(24).fill(false))
            }
        },

        // 开始选择时间段
        startSelection(dayIndex, hour) {
            if (!this.form2.selectedDays[dayIndex]) return

            this.isSelecting = true
            this.selectionStart = { dayIndex, hour }
            this.toggleTime(dayIndex, hour)
        },

        // 鼠标移动选择时间段
        handleMouseEnter(dayIndex, hour) {
            if (this.isSelecting && this.form2.selectedDays[dayIndex]) {
                this.toggleTime(dayIndex, hour)
            }
        },

        // 结束选择
        endSelection() {
            this.isSelecting = false
            this.selectionStart = null
        },

        // 切换时间段选择状态
        toggleTime(dayIndex, hour) {
            const newHours = [...this.form2.selectedHours[dayIndex]]
            newHours[hour] = !newHours[hour]
            this.$set(this.form2.selectedHours, dayIndex, newHours)
        },
        // toggleTime(day, hour) {
        //     const index = this.form2.selectedTimes.findIndex(time =>
        //         time.day === day && time.hour === hour
        //     );

        //     if (index >= 0) {
        //         this.form2.selectedTimes.splice(index, 1);
        //     } else {
        //         this.form2.selectedTimes.push({ day, hour });
        //     }
        // },

        // 判断时间段是否被选中
        isTimeSelected(dayIndex, hour) {
            return this.form2.selectedDays[dayIndex] && this.form2.selectedHours[dayIndex][hour]
        },
        // isTimeSelected(day, hour) {
        //     return this.form2.selectedTimes.some(time =>
        //         time.day === day && time.hour === hour
        //     );
        // },

        // 更新小时选择（根据日期选择）
        updateHoursSelection() {
            this.form2.selectedHours = this.form2.selectedDays.map(selected =>
                selected ? Array(24).fill(true) : Array(24).fill(false)
            )
        },

        // 重置选择
        resetSelection() {
            this.form2.selectedDays = Array(7).fill(false)
            this.form2.selectedHours = Array(7).fill().map(() => Array(24).fill(false))
            this.form2.timeRangeType = '1'
        },

        // 判断日期是否有选中的时间段
        hasSelectedHours(dayIndex) {
            return this.form2.selectedDays[dayIndex] &&
                this.form2.selectedHours[dayIndex].some(hour => hour)
        },

        // 格式化选中的时间段
        formatSelectedHours(dayIndex) {
            if (!this.hasSelectedHours(dayIndex)) return ''

            const hours = this.form2.selectedHours[dayIndex]
            let ranges = []
            let start = null

            for (let i = 0; i <= 24; i++) {
                if (hours[i] && start === null) {
                    start = i
                } else if (!hours[i] && start !== null) {
                    ranges.push(`${start}:00~${i}:00`)
                    start = null
                }
            }

            // 处理跨午夜的情况
            if (hours[23] && hours[0]) {
                if (ranges.length > 1) {
                    const first = ranges[0]
                    const last = ranges[ranges.length - 1]
                    ranges = [
                        `${last.split('~')[0]}~${first.split('~')[1]}`,
                        ...ranges.slice(1, -1)
                    ]
                }
            }

            return ranges.join('、')
        },
        handleAgeChange(selectedValues) {
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                this.form2.selectedAges = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                this.form2.selectedAges = selectedValues.filter(v => v !== allValue);
            }
        },
        handlePriceChange(selectedValues) {
            // console.log(selectedValues);
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.form2.selectedPhonePrices = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.form2.selectedPhonePrices = selectedValues.filter(v => v !== allValue);
            }
        },
        handleNetworkChange(selectedValues) {
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.form2.selectedNetworks = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.form2.selectedNetworks = selectedValues.filter(v => v !== allValue);
            }
        },
        handleCheckAllChange(val) {
            this.form2.selectedMedia = val
                ? this.mediaOptions.map(item => item.value)
                : [];
            this.isIndeterminate = false;
        },
        // 更新全选状态
        updateCheckAllState() {
            const checkedCount = this.form2.selectedMedia.length;
            console.log(checkedCount === this.mediaOptions.length);
            this.checkAll = checkedCount === this.mediaOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.mediaOptions.length;
        },
        adSlothandleCheckAllChange(val) {
            this.form2.selectedAdSlots = val ? this.adSlotOptions.map(item => item.value) : [];
            this.adSlotisIndeterminate = false;
        },

        // 单个选项变化时
        adSlothandleCheckedChange(value) {
            const checkedCount = value.length;
            this.adSlotcheckAll = checkedCount === this.adSlotOptions.length;
            this.adSlotisIndeterminate = checkedCount > 0 && checkedCount < this.adSlotOptions.length;
        },
        handleSaveAndClose() {
            console.log('保存并关闭', this.form);
            // 这里添加保存逻辑
        },
        handleSaveAndCreate() {
            console.log('保存并创建单元', this.form);
            // 这里添加保存并创建逻辑
        },
        handleCancel() {
            console.log('取消');
            // 这里添加取消逻辑
        },
        querySearchAsync(queryString, cb) {
            // 这里实现地区搜索逻辑
            const results = this.regionOptions.filter(region =>
                region.label.includes(queryString)
            );
            cb(results);
        },
        handleSelect(item) {
            // 处理地区选择
            if (!this.form2.selectedRegions.includes(item.value)) {
                this.form2.selectedRegions.push(item.value);
            }
        },
        handleSelecttype(item) {
            console.log(item);
        },
        getDayName(day) {
            const days = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
            return days[day - 1];
        },


        saveAndClose() {
            console.log('保存并关闭', this.form2);
            // 这里添加保存逻辑
        },
        saveAndCreate() {
            console.log('保存并创建创意', this.form2);
            // 这里添加保存并创建创意的逻辑
        },
        cancel() {
            console.log('取消');
            // 这里添加取消逻辑
        },
        getStatusType(status) {
            const typeMap = {
                'waiting': 'info',
                'running': 'warning',
                'done': 'success',
                'failed': 'danger',
                'stopped': 'info',
                'error': 'danger'
            };
            return typeMap[status] || 'info';
        },

        getStatusText(status) {
            const textMap = {
                'waiting': '等待中',
                'running': '运行中',
                'done': '已完成',
                'failed': '失败',
                'stopped': '已停止'
            };
            return textMap[status] || status;
        },

        getProgressStatus(status) {
            const types = {
                'waiting': null,
                'running': null,
                'done': 'success',
                'failed': 'exception'
            };
            return types[status] || null;
        },

        getStepStatusType(status) {
            const types = {
                'wait': 'info',
                'doing': 'warning',
                'success': 'success',
                'error': 'danger'
            };
            return types[status] || 'info';
        },

        getStepStatusText(status) {
            const texts = {
                'wait': '等待',
                'doing': '进行中',
                'success': '成功',
                'error': '失败'
            };
            return texts[status] || status;
        }

    },

};
</script>

<style scoped>
.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}

.orientBtn {
    margin-right: 10px;
}

.orientBtnActive {
    background-color: #409EFF;
    color: #fff;
}

.time-grid {
    margin-top: 15px;
    border: 1px solid #eee;
}

.time-grid-header {
    display: flex;
    border-bottom: 1px solid #eee;
    background-color: #f5f7fa;
}

.time-grid-header>div:first-child {
    width: 80px;
    padding: 10px;
    text-align: center;
}

.time-slots {
    display: flex;
    flex: 1;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    display: flex;
    flex-direction: column;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #eee;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 80px;
    padding: 10px;
    text-align: center;
    background-color: #f5f7fa;
}

.time-cells {
    display: flex;
    flex: 1;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #eee;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell.active {
    background-color: #409EFF;
}

.form-actions {
    margin-top: 30px;
    text-align: center;
}

.form-actions .el-button {
    margin: 0 10px;
}

.adgroup-item {
    color: #1890ff;
    line-height: 20px;
    font-size: 16px;
    border-left: 2px solid #1890ff;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.time-grid {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
}

.time-grid-header {
    display: flex;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.header-label {
    width: 120px;
    padding: 10px;
    text-align: center;
    font-weight: bold;
}

.time-slots {
    flex: 1;
    display: flex;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    background-color: #fff;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 120px;
    padding: 10px;
    display: flex;
    align-items: center;
    border-right: 1px solid #ebeef5;
}

.day-label>>>.el-checkbox {
    width: 100%;
}

.time-cells {
    flex: 1;
    display: flex;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #ebeef5;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell:hover:not(.disabled) {
    background-color: #ecf5ff;
}

.time-cell.active:not(.disabled) {
    background-color: #409eff;
}

.time-cell.disabled {
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.selected-times {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.selected-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.selected-content {
    padding: 15px;
    background-color: #fff;
}

.selected-content div {
    margin-bottom: 5px;
    font-size: 14px;
}

.selected-content div:last-child {
    margin-bottom: 0;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

/* 成功状态样式 */
.creative-item.is-success .el-input__inner {
    border-color: #67c23a;
}

/* 必填项红色星号 */
.creative-item.is-required .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

.style-selector {
    width: 100%;
}

.category {
    margin-bottom: 20px;
}

.category-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    font-weight: bold;
}

.style-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 -8px;
}

.style-list li {
    width: 20%;
    padding: 15px 8px;
    margin-left: 15px;
    margin-bottom: 16px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #e6e7eb;
}

.style-list li.selected {
    border: 1px solid #409eff;
    border-radius: 4px;
}

.style-list li.recommended {
    position: relative;
}

.style-image {}

.style-image img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.style-info {
    display: block;
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    color: #606266;
}

.selected-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
}

.style-tips {
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
}

.bg-image {
    width: 48px;
    height: 48px;
}

.video-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 0 -8px;
}

.video-item {
    flex: 0 0 calc(25% - 12px);
    /* 一行 4 个，减掉间距 */
    box-sizing: border-box;
}

.video-content {
    position: relative;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
    transition: all 0.3s;
}

.video-content:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.video-title {
    width: 70%;
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-thumbnail {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    /* 16:9 比例 */
    position: relative;
    overflow: hidden;
    background: #f5f7fa;
}

.video-thumbnail video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #f56c6c;
}

.adgroup-container {
    position: relative;
    min-height: 100vh;
    padding-bottom: 80px;
    /* 给底部栏留出空间 */
}

.adgroup-main {
    padding: 20px;
    /* 主要内容样式 */
}

.adgroup-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .adgroup-footer {
        flex-direction: column;
        padding: 10px;
    }

    .adgroup-footer .el-button {
        margin: 5px 0 !important;
        width: 100%;
    }
}

.image-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    color: white;
}

.image-count {
    font-size: 14px;
    font-weight: 500;
}

.image-count i {
    margin-right: 8px;
}

.auto-cover-option {
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.auto-cover-option .el-checkbox {
    margin-right: 5px;
}

.auto-cover-option .el-icon-question {
    color: #909399;
    cursor: help;
}

.el-checkbox__label {
    color: white !important;
}

.task-list-container {
    max-height: 70vh;
    overflow-y: auto;
}

.task-card {
    margin-bottom: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 16px;
    background: #fff;
}

.task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.task-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.task-tag {
    min-width: 60px;
    text-align: center;
}

.task-name {
    font-weight: 600;
    font-size: 16px;
    color: #303133;
}

.task-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #909399;
    font-size: 12px;
}

.task-actions {
    display: flex;
    gap: 8px;
}

.user-tasks-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.user-task-item {
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 16px;
    background: #fafafa;
}

.user-header {
    margin-bottom: 12px;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.user-account-name {
    color: #303133;
    font-size: 14px;
}

.user-campaign {
    color: #606266;
    font-size: 12px;
}

.user-status-tag {
    min-width: 50px;
    text-align: center;
}

.user-steps-timeline {
    position: relative;
    padding-left: 20px;
}

.user-timeline-item {
    display: flex;
    margin-bottom: 12px;
    position: relative;
}

.user-timeline-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 12px;
}

.user-marker-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 2;
}

.user-marker-icon.wait {
    background: #f4f4f5;
    color: #c0c4cc;
}

.user-marker-icon.doing {
    background: #ecf5ff;
    color: #409eff;
}

.user-marker-icon.success {
    background: #f0f9ff;
    color: #67c23a;
}

.user-marker-icon.error {
    background: #fef0f0;
    color: #f56c6c;
}

.user-timeline-connector {
    width: 2px;
    flex: 1;
    background: #e4e7ed;
    margin: 2px 0;
}

.user-timeline-content {
    flex: 1;
    padding-bottom: 8px;
}

.user-step-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.user-step-name {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
}

.user-step-status {
    min-width: 40px;
    text-align: center;
}

.user-step-detail {
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
}

/* 创意列表样式 */
.creative-list {
    margin-top: 16px;
    padding: 12px;
    background: white;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
}

.creative-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    font-weight: 600;
    color: #303133;
}

.creative-item {
    margin-bottom: 12px;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid #409EFF;
    background: #f8f9fa;
}

.creative-item.creative-status-done {
    border-left-color: #67c23a;
}

.creative-item.creative-status-failed,
.creative-item.creative-status-error {
    border-left-color: #f56c6c;
}

.creative-item.creative-status-running {
    border-left-color: #e6a23c;
}

.creative-item.creative-status-stopped {
    border-left-color: #909399;
}

.creative-header {
    margin-bottom: 8px;
}

.creative-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.creative-id {
    font-weight: 500;
    color: #303133;
}

.creative-status {
    min-width: 50px;
    text-align: center;
}

.creative-steps {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.creative-step {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
}

.creative-step-marker {
    display: flex;
    align-items: center;
}

.creative-marker {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
}

.creative-marker.wait {
    background: #f4f4f5;
    color: #c0c4cc;
}

.creative-marker.doing {
    background: #ecf5ff;
    color: #409eff;
}

.creative-marker.success {
    background: #f0f9ff;
    color: #67c23a;
}

.creative-marker.error {
    background: #fef0f0;
    color: #f56c6c;
}

.creative-step-content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.creative-step-name {
    font-size: 12px;
    color: #606266;
    min-width: 80px;
}

.creative-step-status {
    min-width: 35px;
    text-align: center;
}

.creative-step-detail {
    font-size: 11px;
    color: #909399;
    flex: 1;
}

.empty-state {
    text-align: center;
    padding: 40px 0;
}

/* 状态颜色 */
.status-wait .user-marker-icon {
    background: #f4f4f5;
    color: #c0c4cc;
}

.status-doing .user-marker-icon {
    background: #ecf5ff;
    color: #409eff;
}

.status-success .user-marker-icon {
    background: #f0f9ff;
    color: #67c23a;
}

.status-error .user-marker-icon {
    background: #fef0f0;
    color: #f56c6c;
}

.media-gallery {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.media-item {
    position: relative;
    width: 148px;
    height: 148px;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
    transition: all 0.3s ease;
}

.media-item:hover {
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.media-content {
    position: relative;
    width: 100%;
    height: 100%;
}

.media-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.file-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 8px;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.media-item:hover .file-info {
    transform: translateY(0);
}

.file-name {
    display: flex;
    align-items: center;
    color: white;
    font-size: 12px;
    text-decoration: none;
}

.file-name i {
    margin-right: 4px;
    font-size: 14px;
}

.file-status {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #67c23a;
}

.media-actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.media-item:hover .media-actions {
    opacity: 1;
}

.action-preview,
.action-replace,
.action-delete {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    color: #606266;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.action-preview:hover {
    background: #409eff;
    color: white;
}

.action-replace:hover {
    background: #e6a23c;
    color: white;
}

.action-delete:hover {
    background: #f56c6c;
    color: white;
}

.position-index {
    position: absolute;
    top: 4px;
    left: 4px;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/qutotiaopida.vue